import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import moment from 'moment'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/RemuneracaoMedica'
import { Apis } from '@finx/web-repository'
import { isEqual, filtrarItensPorAcao } from '@/utils/common'
import { RemuneracaoMedica } from '@/types/core'
// eslint-disable-next-line
import {
  CargaRemuneracaoLog,
  PrestadorRecebimento,
  SituacaoRemuneracaoEnum,
  SituacoesFiltro,
  TemplateNotificarConfig,
  PrestadoresRecebimentoSearch,
  TabelasDeReferencia,
  BackofficeProducao,
  Procedimentos,
  ItemsCargaRemuneracao,
  ItemSenioridade,
  ItemAvulso,
  ItemTabelaPrecoProcedimento,
  ItemPontuacaoProfissional,
  ItemTaxaAluguel,
  PrestadorTaxaAluguel,
  TaxaAluguelTipoEnum,
  MensagensDaApiEnum,
// eslint-disable-next-line
} from '@/types/_'
import { IRemuneracaoBackofficeMessage } from '@/types/interfaces/backoffice-remuneracao/backoffice-remuneracao-message'
import { signalRRemuneracaoBackofficeService } from '../../../../services/signalR-remuneracao-backoffice.service'

const TAXA_PADRAO = 'TAXA PADRÃO'

@Module({ namespaced: true, name: 'FinanceiroStore' })
export default class FinanceiroStore extends VuexModule {
  public modal: any = {
    atualizarNotaFiscal: false,
    multiplasNotasFiscais: false,
    editarNotaFiscal: false,
    desfazerLiberacao: false,
    criarEditarItemSenioridade: false,
    criarEditarItemTabelaPrecoProcedimento: false,
    novoItemAvulsoRepasse: false,
    validacaoEGeracaoRepasse: false,
    procedimentosDescartados: false,
    gerarRepasse: false,
    emitirRelatorioEmLote: false,
    itensDoRepasse: false,
    modalAlterarAluguelPrestador: false,
    modalAlterarPontuacaoProfissional: false,
    modalAlterarPrestador: false,
    criarEditarItemPontuacaoProfissional: false,
    criarEditarItemTaxaAluguel: false,
    excluirItemRepasse: false,
    filtroDownloadNotaFiscal: false,
    descontosPrestador: false,
    integrarRepasses: false,
    integrarRepasseUnico: false,
    liberarRepasses: false,
    emitirRelatorio: false,
    descartarRepasses: false,
    desfazerIntegracao: false,
    errosValidacao: false,
    liberarRepasseUnico: false,
    modelosCargaRemuneracao: false,
    recalcularRepasse: false,
    itemsRecebimentoMonitor: false,
    itemsRecebimentoErros: false,
    repassesCarregados: false,
    integrarRepasseMultiplo: false,
    liberarRepasseMultiplo: false,
    criarTabelaPreco: false,
  }

  private agrupamentoRepasseDefault: any = {
    message: '',
    agrupamento: {
      id: '',
      numeroChamado: '',
    },
    somatorioTotalNotas: 0,
    arquivoNotasFiscais: '',
  }

  private exportarRegistrosDefault: any = {
    message: '',
    registros: {
      grupoRepasseId: '',
      anoMesReferencia: '',
      fontePagadoraId: '',
    },
  }

  private finalizarProcessosDefault: any = {
    message: '',
    processos: {
      grupoRepasseId: '',
      anoMesReferencia: '',
      fontePagadoraId: '',
    },
  }

  private itensDoRepasseDefault: any = {
    dataRecebimento: '',
    empresaMedicaDocumento: '',
    empresaMedicaNome: '',
    fontePagadoraDocumento: '',
    fontePagadoraNome: '',
    itens: [{
      id: '',
      acomodacao: '',
      codigoTuss: '',
      dataRealizacao: '',
      dataRecebimento: '',
      descricaoTuss: '',
      fontePagadoraNome: '',
      funcaoDescricao: '',
      localExecucaoNome: '',
      numeroAtendimento: '',
      operadoraNome: '',
      paciente: '',
      profissionalNome: '',
      quantidade: 0,
      urgente: false,
      valorBruto: 0,
      viaAcesso: '',
    }],
    mesReferenciaPagamento: '',
    numeroRepasse: '',
    paginaAtual: 0,
    totalPaginas: 0,
    totalRegistros: 0,
    valorTotal: 0,
  }

  private prestadorRecebimentoDefault: PrestadorRecebimento = {
    id: '',
    documentoId: '',
    fontePagadoraNome: '',
    fontePagadoraDocumento: '',
    numeroRepasse: '',
    prestadorNome: '',
    numeroChamado: 0,
    prestadorDocumento: '',
    dataLiberacao: '',
    dataPrevisaoPagamento: '',
    ordemDeCompra: '',
    numeroPedido: '',
    mesReferenciaPagamento: 1,
    numeroAtendimento: '',
    descricaoDivergencia: '',
    valorNota: 0,
    valorRepasse: 0,
    motivo: [],
    divergencia: false,
    dataRecebimentoNota: '',
    numeroNota: '',
    numeroContasPagar: 0,
    layoutRelatorio: 0,
    comentario: '',
    medicoNome: [],
    nomeArquivoOriginal: '',
    codPrestador: '',
    codFontePagadora: '',
    responsavelCodHis: '',
    inscricaoMunicipal: '',
    userId: '',
    notasFiscais: [
      {
        createdByNome: '',
        createdOn: '',
        dataRecebimentoNota: '',
        descricaoDivergencia: '',
        divergencia: false,
        documentoId: '',
        motivo: [],
        nomeArquivoOriginal: '',
        notaCancelada: false,
        numeroContasPagar: '',
        numeroNota: '',
        prestadorRecebimentoId: '',
        situacao: '',
        valorNotaFiscal: 0,
        comentario: '',
      },
    ],
    fontePagadoraId: {
      display: '',
      key: '',
    },
    grupoRepasseId: {
      display: '',
      key: '',
    },
    grupoRepasse: {
      display: '',
      key: 0,
    },
    acoes: {
      atualizar: false,
      falarPrestador: false,
      podeProvisionar: false,
      visualizar: false,
      podeDeletarNotaFiscal: false,
      podeCancelarProvisionamento: false,
    },
    dataUltimaNotificacao: '',
    situacao: {
      display: '',
      key: '',
    },
    notaCancelada: false,
  }

  private templateNotificarConfigDefault: TemplateNotificarConfig = {
    assunto: '',
    emailContato: '',
    emailCorpo: '',
    emailResposta: '',
    nomeHospital: '',
    tipo: 0,
  }

  private profissionaisExecutantesDefault: any[] = []
  private motivosInclusaoItemAvulsoDefault: any[] = []
  private codigoProcedimentoDefault: any[] = []
  private transacaoFiananceiraDefault: any[] = []
  private centroDeCustoDefault: any[] = []

  private pontuacoesDefault: any[] = []

  private tabelasAMBDefault: any = {
    id: '',
    nome: '',
  }

  private itemsTabelaPrecoDefault: any[] = []

  private itemsTabelaPrecoIndiceDefault: any[] = []

  private itemsConveniosRegrasDefault: any[] = []

  private itemAvulsoDefault: ItemAvulso = {
    id: '',
    valor: 0,
    transacaoFinanceira: '',
    contaContabil: '',
    centroDeCusto: '',
    profissional: '',
    observacao: '',
    urgente: false,
  }

  private prestadoresRecebimentosDefault: PrestadorRecebimento[] = []
  private itemsCargaRemuneracaoDefault: ItemsCargaRemuneracao[] = []
  private backofficeProcedimentosDefault: Procedimentos[] = []
  private geracaoDeRepassesItemsDefault: any[] = []
  private tabelasDeReferenciaDefault: TabelasDeReferencia[] = []
  private backofficeProducaoDefault: BackofficeProducao[] = []
  public itemAvulso: ItemAvulso = { ...this.itemAvulsoDefault }
  public geracaoDeRepassesItems: any[] = [...this.geracaoDeRepassesItemsDefault]
  public geracaoDeRepassesItemsVisualizar: any[] = []
  public cargasVisualizarItems: any[] = []
  public procedimentosDescartados: any[] = []
  public acoesGeracaoRepasse: any = {}
  public activeTab: number = 0
  public dadosGeraisDoRepasse: any = {}
  public relatorioId: string = ''
  public pessoaId: string = ''
  public impostoId: string = ''
  public alicota: string = ''
  public valorMinimoTributo: string = ''
  public geracaoDeRepassesItemsPrestador: any[] = []
  public notaFiscalUnica: any = {}
  public documentoId: any = ''
  public prestadorRecebimento: PrestadorRecebimento = { ...this.prestadorRecebimentoDefault }
  public backofficeProcedimentos: Procedimentos[] = { ...this.backofficeProcedimentosDefault }
  public templateNotificarConfig: TemplateNotificarConfig = { ...this.templateNotificarConfigDefault }
  public prestadoresRecebimentos: PrestadorRecebimento[] = [...this.prestadoresRecebimentosDefault]
  public colunasOcultarItems: any[] = []
  public itemsCargaRemuneracao: ItemsCargaRemuneracao[] = [...this.itemsCargaRemuneracaoDefault]
  public itemsDownloadNotasFiscais: any[] = []
  public vinculosRelatorios: any[] = []
  public itemsMonitoramentoCargas: any[] = []
  public tipoFilter: any = ''
  public totalItemsMonitoramentoCargas: number = 0
  public impostoPrestadores: any[] = []
  public relatoriosAll: any[] = []
  public totalItemsDownloadNotasFiscais: number = 0
  public anoMesReferenciaDownloadNotasFiscais: string = ''
  public createdOnNFDe: string = ''
  public createdOnNFAte: string = ''
  public fontePagadoraIdDownloadNotasFiscais: string = ''
  public grupoRepasseDownloadNotasFiscais: string = ''
  public situacoesDoRepasseDownloadNotasFiscais: string = ''
  public tabelasDeReferencia: TabelasDeReferencia[] = [...this.tabelasDeReferenciaDefault]
  public itensRecebimentoMonitor: any[] = []
  public repassesCarregados: any[] = []
  public totalItensRepassesCarregados: number = 0
  public itensRecebimentoErros: any[] = []
  public backofficeProducao: BackofficeProducao[] = [...this.backofficeProducaoDefault]
  public cargaLogs: CargaRemuneracaoLog[] = []
  public itemsTabelaValidacao: any[] = []
  public tabelasAMB: any = { ...this.tabelasAMBDefault }
  public itemsTabelaPreco: any[] = [...this.itemsTabelaPrecoDefault]
  public itemsTabelaPrecoDetails: any[] = []
  public itemsTabelaPrecoIndice: any[] = [...this.itemsTabelaPrecoIndiceDefault]
  public itemsConveniosRegras: any[] = [...this.itemsConveniosRegrasDefault]
  public itemsTabelaAmb: any[] = []
  public itemsRegrasProfissional: any[] = []
  public descontosPrestador: any[] = []
  public agrupamentoRepasse: any = { ...this.agrupamentoRepasseDefault }
  public exportarRegistros: any = { ...this.exportarRegistrosDefault }
  public finalizarProcessos: any = { ...this.finalizarProcessosDefault }
  public itensDoRepasse: any = { ...this.itensDoRepasseDefault }
  public relatorioEmitido: any = {}
  public downloadTipoCarga: any = {}
  public notaFiscalItem: any = {}
  public idForDeleteNotaFiscal: string = ''
  public relatorioEmissaoId: string = ''
  public descarteId: string = ''
  public emitirRelatorioEmLote: string[] = []
  public validacaoErros: any[] = []
  public situacoes: string[] = []
  public funcoes: string[] = []
  public statusGeracaoRepasse: string[] = []
  public fontePagadoraFilter: string = ''
  public tipoItens: string = ''
  public apenasDivergente: boolean = false
  public alterarFuncao: string = ''
  public situacoesValidacao: string[] = ['Calculado']
  public errosValidacao: string[] = []
  public tabelaPropria: string = ''
  public tabelaId: string[] = []
  public convenioRegras: string = ''
  public multiplicador: string = ''
  public taxaAdm: string = ''
  public valorDeReferencia: string = ''
  public aplicarFatorAcomodacao: boolean = false
  public indiceAtualRegras: boolean = false
  public tabelaReferencia: string = ''
  public tabelaIndice: string = ''
  public itemUpdateId: string = ''
  public profissionalRegrasId: string = ''
  public fontePagadoraRegrasId: string = ''
  public codigoTuss: string = ''
  public codigoAMB: string = ''
  public medicoProducaoProcedimentoId: string = ''
  public descricaoTuss: string = ''
  public modalContext: any = null
  public isNewNotaFiscal: boolean = false
  public nome: string = ''
  public tabelaAmbId: string = ''
  public profissionaisExecutantes: any[] = [...this.profissionaisExecutantesDefault]
  public prestadoresRepasse: any[] = []
  public statusGeracaoRepasseFiltro: any[] = []
  public funcoesProfissionalExecutante: any[] = []
  public conveniosRepasse: any[] = []
  public conveniosList: any[] = []
  public planosRepasse: any[] = []
  public viasAcesso: any[] = []
  public motivosInclusaoItemAvulso: any[] = [...this.motivosInclusaoItemAvulsoDefault]
  public codigoProcedimento: any[] = [...this.codigoProcedimentoDefault]
  public transacaoFinanceira: any[] = [...this.transacaoFiananceiraDefault]
  public centroDeCusto: any[] = [...this.centroDeCustoDefault]
  public codigoProcedimentoId: string = ''
  public observacao: string = ''
  public urgente: boolean = false
  public excelRepasse: any = null
  public numeroAtendimento: string = ''
  public hisProcedimento: string = ''
  public dataAtendimento: string = ''
  public codigoItens: string = ''
  public itemAvulsoRepasse: any = {}
  public centroDeCustoId: string = ''
  public transacaoFinanceiraId: string = ''
  public valorProcedimento: number = 0
  public quantidade: number = 0
  public pontuacoes: any = [...this.pontuacoesDefault]
  public convenio: string = ''
  public situacoesFiltro: SituacoesFiltro[] = []
  public funcoesFiltro: any[] = []
  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public filterValidacaoEGeracaoRepasseDrawer: boolean = false
  public geracaoDrawer: boolean = false
  public filterProcedimentosDescartadosDrawer: boolean = false
  public agrupamentoRpas: boolean = false
  public profissionais: string = ''
  public convenios: string = ''
  public solicitacaoId: string = ''
  public tiposCarga: any[] = []
  public disabledConfirmar: boolean = false
  public tipoCargaSelected: string = ''

  private paginaDefault: number = 1
  private pageItemsDefault: number = 1
  private paginaProducaoDefault: number = 1
  private somatorioTotalNotasDefault: number = 0
  private qtdPorPaginaDefault: number = 50
  // private filtroTextoDefault: string = ''
  private prestadoresListaDefault: PrestadoresRecebimentoSearch[] = []

  public pagina: number = this.paginaDefault
  public paginaRepassesCarregados: number = this.paginaDefault
  public paginaGeracao: number = this.paginaDefault
  public idForLoadValidacaoEGeracaoRepasse: string = ''
  public idForCloseGeracao: string = ''
  public idForLoadProcedimentosDescartados: string = ''
  public temProcedimento: boolean = false
  public podeLiberar: string = ''
  public podeDescartar: boolean = false
  public idForLoadItensRepasse: string = ''
  public idForLoadPrestadores: string = ''
  public prestadorRecebimentoId: string = ''
  public statusGeracaoDeRepasse: string = ''
  public idForLoadItemAvulso: string = ''
  public pageItems: number = this.pageItemsDefault
  public paginaProducao: number = this.paginaProducaoDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  // public filtroTexto: string = this.filtroTextoDefault
  public totalPrestadorRemuneracao: number = 0
  public totalGeracaoDeRepasse: number = 0
  public exibirNumeroChamado: boolean = false
  public tipoEnum: string[] = []
  public totalItensPrestador: number = 0
  public quantidadeTotal: number = 0
  public valorTotal: number = 0
  public totalItemsCargaRemuneracao: number = 0
  public mensagemLogDesfazer: string = ''
  public itemsTabelaValidacaoTotal: number = 0
  public totalGeracaoDeRepasseVisualizar: number = 0
  public totalProcedimentosDescartados: number = 0
  public totalRepasseItems: number = 0
  public itemsId: string = ''
  public totalTabelaDeReferencia: number = 0
  public totalBackofficeProducao: number = 0
  public totalPageBackofficeProducao: number = 0
  public grupoRepasse: string = ''
  public grupoRepasseFinalizarProcessos: string = ''
  public layoutRelatorio: boolean | null = false
  public grupoRepasseItens: any[] = []
  public linkParaEnvioDaNF: string = ''
  public itemRepasse: any = {}
  public grupoRepasseItensAll: any[] = []
  public fontePagadoraId: string = ''
  public situacoesExportarRegistros: string = ''
  public estabelecimentoGerarRepasseId: string = ''
  public prestadorGerarRepasse: string = ''
  public condicaoPagamentoGerarRepasseId: string = ''
  public tipoAluguelPrestador: string = ''
  public valorAluguelPrestador: string = ''
  public motivoInclusao: string = ''
  public profissionalPontuacao: string = ''
  public prestadorRepasse: any = {}
  public funcaoProfissionalExecutante: string = ''
  public convenioRepasse: string = ''
  public planoRepasse: string = ''
  public viaAcesso: string = ''
  public pontuacaoProfissional: string = ''
  public aluguelPrestadorId: string = ''
  public grupoRepasseId: string = ''
  public fontePagadoraIdExportarRegistros: string = ''
  public numeroChamado: string = ''
  public email: string = ''
  public nomePrestador: string = ''
  public codigoRegra: string = ''
  public buscaProducao: string = ''
  public somatorioTotalNotas: number = this.somatorioTotalNotasDefault
  public fontePagadoras: any[] = []
  public tipoItensList: any[] = []
  public profissionaisList: any[] = []
  public gerarRepassePrestadores: any[] = []
  public statusList: any[] = []
  public selectedPrestador: string = ''
  public selectedTipo: any[] = []
  public selectedStatus: any[] = []
  public condicoesPagamento: any[] = []
  public anoMesReferencia: string = ''
  public anoMesReferenciaDe: string = ''
  public anoMesReferenciaAte: string = ''
  public anoMesReferenciaListaRepasse: string = ''
  public anoMesReferenciaExportarRegistros: string = ''
  public relatorioSelected: string = ''
  public anoMesReferenciaFinalizarProcessos: string = ''
  public anoMesReferenciaGeracaoRepasse: string = ''
  public impostoPrestadorId: string = ''
  public anoMesReferenciaDoRepasse: string = ''
  public dataEnvioNotaFiscalGeracaoRepasse: string = ''
  public dataVencimentoGeracaoRepasse: string = ''
  public anoMesReferenciaRecalcularValores: string = ''
  public dataRecebimentoRecalcularValores: string = ''
  public prazoRecalcularValores: string = ''
  public numeroRepasse: string = ''
  public contasPagar: string = ''
  public numeroNota: string = ''
  public valorNota: string = ''
  public enablePodeEncerrarRepasses: boolean = false
  public prestadorId: string = ''
  public profissionalRepasse: string = ''
  public medicoRecebimentoIds: any[] = []
  public nomePaciente: string = ''
  public numeroConta: string = ''
  public seqProcedimentoHis: string = ''
  public operadoraId: string = ''
  public planoOperadoraId: string = ''
  public profissionalExecutanteId: string = ''
  public competenciaFaturamentoAnoMes: string = ''
  public competenciaRepasseAnoMes: string = ''
  public codigoRepasse: string = ''
  public exibirOpcaoRelatorioAssinaturaDiretoria: boolean = false
  public prestadoresLista: PrestadoresRecebimentoSearch[] = [...this.prestadoresListaDefault]
  public impostoPrestadorList: any[] = []
  public idForSaveAlterarPrestador: string = ''
  public idForDesfazerRepasse: string = ''
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  public backofficeProducaoHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome paciente', value: 'nomePaciente', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Local execução', value: 'localExecucao', sortable: false },
    { text: 'Data Realização', value: 'dataRealizado', sortable: false },
    { text: 'Valor total', value: 'valorTotal', sortable: false },
    { text: 'Status do pagamento', value: 'statusPagamento', sortable: false },
  ]

  public descontosPrestadorHeader: any[] = [
    { text: 'Nome', value: 'nome', align: 'center', sortable: false },
    { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
    { text: 'Percentual', value: 'percentual', align: 'center', sortable: false },
  ]

  public headersTabelaValidacao: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Profissional', value: 'profissional', sortable: false },
    { text: 'Função', value: 'funcao', sortable: false },
    { text: 'Código TUSS', value: 'codigoProc', sortable: false },
    { text: 'Convênio', value: 'convenio', sortable: false },
    { text: 'Data da cirurgia', value: 'dataCirurgia', sortable: false },
    { text: 'Qtde.', value: 'quantidade', sortable: false },
    { text: 'Faturado', value: 'faturado', sortable: false },
    { text: 'Repassado', value: 'repassado', sortable: false },
    { text: '% Repassado', value: 'porcentagemRepassado', sortable: false },
    { text: 'Situação', value: 'situacao', sortable: false },
    { text: 'Ações', value: 'acoes', sortable: false },
  ]

  public headersTabelaAMB: any[] = [
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Código Tuss', value: 'codigoTuss', align: 'center', sortable: false },
    { text: 'Descrição Tuss', value: 'descricaoTuss', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'left', sortable: false },
  ]

  public headersRegraProfissional: any[] = [
    { text: 'Código regra', value: 'codigoHisRegra', align: 'center', sortable: false },
    { text: 'Descrição regra', value: 'descricaoRegra', align: 'center', sortable: false },
    { text: 'Fonte Pagadora', value: 'nomePrestador', align: 'center', sortable: false },
    { text: 'Convênio', value: 'nomeFontePagadora', align: 'center', sortable: false },
    { text: 'Multiplicador', value: 'fatorMedico', align: 'center', sortable: false },
    { text: 'Taxa Adm.', value: 'percentualTaxaAdministrativa', align: 'center', sortable: false },
    { text: 'Tabela referência', value: 'nomeTabelaPreco', align: 'center', sortable: false },
    { text: 'Tabela Índice', value: 'nomeTabelaIndice', align: 'center', sortable: false },
    { text: 'Editar', value: 'edit', align: 'center', sortable: false },
  ]

  public headersRegrasProfissional: any[] = [
    { text: 'Nome Profissional', value: 'nomeProfissional', sortable: false },
    { text: 'Nome Prestador', value: 'nomePrestador', sortable: false },
    { text: 'Nome Fonte Pagadora', value: 'nomeFontePagadora', sortable: false },
    { text: 'Categoria Dedicação', value: 'categoriaDedicacao', sortable: false },
    { text: 'Data da Cirurgia', value: 'dataCirurgia', sortable: false },
    { text: 'Pontuação Dedicação', value: 'pontuacaoDedicacao', sortable: false },
  ]

  public headersTabelaDeSenioridade: any[] = [
    { text: 'Categoria dedicação', value: 'categoiriaDeticacao', align: 'center', sortable: false },
    { text: 'Pontuação dedicação', value: 'pontuacaoDedicacao', align: 'center', sortable: false },
    { text: 'Percentual incentivo', value: 'percentualIncentivo', align: 'center', sortable: false },
  ]

  public backofficeProcedimentosHeader: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Descricao', value: 'descricao', align: 'center', sortable: false },
    { text: 'Sequencia', value: 'sequencia', align: 'center', sortable: false },
    { text: 'Quantidade', value: 'quantidade', align: 'center', sortable: false },
    { text: 'Via', value: 'viaAcesso', align: 'center', sortable: false },
  ]

  public tabelasDeReferenciaTableHeader: any[] = [
    { text: 'Nome tabela', value: 'nomeTabela', sortable: false },
    { text: 'Cód. único', value: 'codigoUnico', sortable: false },
    { text: 'Descrição', value: 'descricao', sortable: false },
    { text: 'Valor recebimento', value: 'valorProcedimento', sortable: false },
    { text: 'Fator via única', value: 'fatorViaUnica', sortable: false },
    { text: 'Fator via separada', value: 'fatorViaSeparada', sortable: false },
    { text: 'Fator via bilateral', value: 'fatorViaBilateral', sortable: false },
    { text: 'Fator via mesma', value: 'fatorViaMesma', sortable: false },
    { text: 'Fator cirurgião', value: 'fatorCirurgiao', sortable: false },
    { text: 'Fator auxiliar 1', value: 'fatorAuxiliar1', sortable: false },
    { text: 'Fator auxiliar 2', value: 'fatorAuxiliar2', sortable: false },
    { text: 'Fator auxiliar 3', value: 'fatorAuxiliar3', sortable: false },
    { text: 'Fator auxiliar 4', value: 'fatorAuxiliar4', sortable: false },
  ]

  public tabelaCargaRemuneracaoHeader: any[] = [
    { text: 'Data da criação', value: 'createdOn', sortable: true },
    { text: 'Criado por', value: 'createdByNome', sortable: false },
    { text: 'Tipo', value: 'tipóImportacao', sortable: false },
    { text: 'Nome arquivo', value: 'nomeArquivo', sortable: false },
    { text: 'Total de itens', value: 'totalItens', sortable: false },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Erro', value: 'temErro', sortable: true },
    { text: 'Concluido em', value: 'concluidoEm', sortable: false },
    { text: 'Log', value: 'log', align: 'center', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public tabelaDownloadNotasFiscais: any[] = [
    { text: 'Data da criação', value: 'createdOn', sortable: false },
    { text: 'Nome arquivo', value: 'nomeArquivo', sortable: false },
    { text: 'Nome usuário', value: 'nomeUsuario', sortable: false },
    { text: 'Nome grupo repasse', value: 'nomeGrupoRepasse', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Situação', value: 'situacao', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public notasFiscaisTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Grupo de repasse', align: 'center', value: 'grupoRepasseNome', sortable: false },
    { text: 'Fonte pagadora', align: 'center', value: 'fontePagadora', sortable: false },
    { text: 'Contas a pagar', align: 'center', value: 'numeroContasPagar', sortable: true },
    { text: 'Responsável', align: 'center', value: 'responsavelNome', sortable: true },
    { text: 'Empresa médica', align: 'center', value: 'empresaMedicaNome', sortable: true },
    { text: 'Valor da nota', align: 'center', value: 'valorNota', sortable: true },
    { text: 'Número da nota', align: 'center', value: 'numeroNotas', sortable: false },
    { text: 'Número do chamado', align: 'center', value: 'numeroChamado', sortable: false },
    { text: 'Ação', align: 'center', value: '', sortable: false },
    { text: 'Situação repasse', align: 'center', value: 'situacao', sortable: false },
    { text: '', align: 'center', value: 'historico', sortable: false },
  ]

  public backofficeVisualizarItensHeaders: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome paciente', value: 'paciente', sortable: false },
    { text: 'Nome profissional', value: 'profissionalNome', sortable: false },
    { text: 'Data realizada', value: 'dataRealizacao', sortable: false },
    { text: 'Função', value: 'funcaoDescricao', sortable: false },
    { text: 'Via', value: 'viaAcesso', sortable: false },
    { text: 'Qtde.', value: 'quantidade', sortable: false },
    { text: 'Valor profissional', value: 'valorBruto', sortable: false },
  ]

  public validacaoRepasseErrosHeader: any[] = [
    { text: 'Data', value: 'data', align: 'center', sortable: false },
    { text: 'Tipo.', value: 'tipo', align: 'center', sortable: false },
    { text: 'Mensagem', value: 'mensagem', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseHeaders: any[] = [
    { text: 'Data geração', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Usuário', value: 'createdByNome', align: 'center', sortable: false },
    { text: 'Estabelecimento', value: 'nomeEstabelecimento', align: 'center', sortable: false },
    { text: 'Competência', value: 'mesAnoCompetencia', align: 'center', sortable: false },
    { text: 'Qtde de repasses', value: 'totalRepasses', align: 'center', sortable: false },
    { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseVisualizarHeaders: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Grupo de repasse', value: 'grupoRepasse', align: 'center', sortable: false },
    { text: 'Fonte Pagadora', value: 'fontePagadora', align: 'center', sortable: false },
    { text: 'Prestador', value: 'prestador', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Valor', value: 'valor', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseItensHeaders: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Profissional', value: 'profissional', align: 'center', sortable: false },
    { text: 'Função', value: 'funcao', align: 'center', sortable: false },
    { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
    { text: 'Convênio', value: 'convenio', align: 'center', sortable: false },
    { text: 'Numero atendimento', value: 'numeroAtendimento', align: 'center', sortable: false },
    { text: 'Data execução', value: 'dataExecucao', align: 'center', sortable: false },
    { text: 'Valor', value: 'valor', align: 'center', sortable: false },
    { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
  ]

  public logsTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Exception', value: 'exception', sortable: false },
    { text: 'Data', value: 'createOn', sortable: false },
  ]

  public search: string = ''
  public searchCodigo: string = ''
  public searchDescricao: string = ''
  public searchCodigoDebounce: string = ''
  public searchDescricaoDebounce: string = ''
  public anexos: any[] = []
  public deleteNotaFiscalId: string = ''
  public sortBy: string = ''
  public idForConfirmar: any = ''

  @Mutation
  setIdForConfirmar(value: any) {
    this.idForConfirmar = value
  }

  @Mutation
  setActiveTab(tab: number) {
    this.activeTab = tab
  }

  @Mutation
  setAgrupamentoRpas(value: boolean) {
    this.agrupamentoRpas = value
  }

  @Mutation
  setNomePrestador(value: string) {
    this.nomePrestador = value
  }

  @Mutation
  setCodigoRegra(value: string) {
    this.codigoRegra = value
  }

  @Mutation
  setBuscaProducao(value: string) {
    this.buscaProducao = value
  }

  @Mutation
  setSortBy(value: string) {
    this.sortBy = value
  }

  @Mutation
  solicitacaoIdRepasse(value: string) {
    this.solicitacaoId = value
  }

  @Mutation
  setTemProcedimento(value: boolean) {
    this.temProcedimento = value
  }

  @Mutation
  clearSortByFilter() {
    this.sortBy = ''
  }

  @Mutation
  setNome(value: string) {
    this.nome = value
  }

  @Mutation
  clearItensDoRepasse() {
    this.itensDoRepasse = { ...this.itensDoRepasseDefault }
  }

  @Mutation
  clearBackofficeProcedimentos() {
    this.backofficeProcedimentos = { ...this.backofficeProcedimentosDefault }
  }

  @Mutation
  setDeleteNotaFiscalId(value: string) {
    this.deleteNotaFiscalId = value
  }

  @Mutation
  clearDeleteNotaFiscalId() {
    this.deleteNotaFiscalId = ''
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setGeracaoDrawer(value: boolean) {
    this.geracaoDrawer = value
  }

  @Mutation
  setRelatorioId(value: string) {
    this.relatorioId = value
  }

  @Mutation
  setPessoaId(value: string) {
    this.pessoaId = value
  }

  @Mutation
  setImpostoId(value: string) {
    this.impostoId = value
  }

  @Mutation
  setAlicota(value: string) {
    this.alicota = value
  }

  @Mutation
  setvalorMinimoTributo(value: string) {
    this.valorMinimoTributo = value
  }

  @Mutation
  setFilterValidacaoEGeracaoRepasseDrawer(value: boolean) {
    this.filterValidacaoEGeracaoRepasseDrawer = value
  }

  @Mutation
  setFilterProcedimentosDescartadosDrawer(value: boolean) {
    this.filterProcedimentosDescartadosDrawer = value
  }

  @Mutation
  setAgrupamentoRepasse(value: any) {
    this.agrupamentoRepasse = value
  }

  @Mutation
  setExportarRegistros(value: any) {
    this.exportarRegistros = value
  }

  @Mutation
  setFinalizarProcessos(value: any) {
    this.finalizarProcessos = value
  }

  @Mutation
  setItensDoRepasse(value: any) {
    this.itensDoRepasse = value
  }

  @Mutation
  setRelatorioEmitido(value: any) {
    this.relatorioEmitido = value
  }

  @Mutation
  setDownloadTipoCarga(value: any) {
    this.downloadTipoCarga = value
  }

  @Mutation
  setNotaFiscalItem(value: any) {
    this.notaFiscalItem = value
  }

  @Mutation
  setNotaFIscalItemAnexo(value: any) {
    this.notaFiscalItem.nomeArquivoOriginal = value
  }

  @Mutation
  setIdForDeleteNotaFiscal(value: string) {
    this.idForDeleteNotaFiscal = value
  }

  @Mutation
  setRelatorioEmissaoId(value: string) {
    this.relatorioEmissaoId = value
  }

  @Mutation
  setDescarteId(value: string) {
    this.descarteId = value
  }

  @Mutation
  setValidacaoErros(value: any[]) {
    this.validacaoErros = value
  }

  @Mutation
  setItemsTabelaValidacao(value: any) {
    this.itemsTabelaValidacao = value
  }

  @Mutation
  setTabelasAMB(value: any) {
    this.tabelasAMB = value
  }

  @Mutation
  setItemsTabelaPreco(value: any[]) {
    this.itemsTabelaPreco = value
  }

  @Mutation
  setItemsTabelaPrecoDetails(value: any[]) {
    this.itemsTabelaPrecoDetails = value
  }

  @Mutation
  setItemsTabelaPrecoIndice(value: any[]) {
    this.itemsTabelaPrecoIndice = value
  }

  @Mutation
  setConveniosRegras(value: any[]) {
    this.itemsConveniosRegras = value
  }

  @Mutation
  setItemsTabelaAmb(value: any) {
    this.itemsTabelaAmb = value
  }

  @Mutation
  setItemsRegrasProfissional(value: any[]) {
    this.itemsRegrasProfissional = value
  }

  @Mutation
  setConvenioRegras(value: any) {
    this.convenioRegras = value
  }

  @Mutation
  setMultiplicador(value: any) {
    this.multiplicador = value
  }

  @Mutation
  setTipoAluguelPrestador(value: string) {
    this.tipoAluguelPrestador = value
  }

  @Mutation
  setValorAluguelPrestador(value: string) {
    this.valorAluguelPrestador = value
  }

  @Mutation
  setAnoMesReferenciaDownloadNotasFiscais(value: string) {
    this.anoMesReferenciaDownloadNotasFiscais = value
  }

  @Mutation
  setCreatedOnNFDe(value: string) {
    this.createdOnNFDe = value
  }

  @Mutation
  setCreatedOnNFAte(value: string) {
    this.createdOnNFAte = value
  }

  @Mutation
  setSituacoesDoRepasseDownloadNotasFiscais(value: string) {
    this.situacoesDoRepasseDownloadNotasFiscais = value
  }

  @Mutation
  setFontePagadoraIdDownloadNotasFiscais(value: string) {
    this.fontePagadoraIdDownloadNotasFiscais = value
  }

  @Mutation
  setGrupoRepasseDownloadNotasFiscais(value: string) {
    this.grupoRepasseDownloadNotasFiscais = value
  }

  @Mutation
  setProfissionalPontuacao(value: string) {
    this.profissionalPontuacao = value
  }

  @Mutation
  setPrestadorRepasse(value: any) {
    this.prestadorRepasse = value
  }

  @Mutation
  setFuncaoProfissionalExecutante(value: string) {
    this.funcaoProfissionalExecutante = value
  }

  @Mutation
  setConvenioRepasse(value: string) {
    this.convenioRepasse = value
  }

  @Mutation
  setPlanoRepasse(value: string) {
    this.planoRepasse = value
  }

  @Mutation
  setViaAcesso(value: string) {
    this.viaAcesso = value
  }

  @Mutation
  setMotivoInclusao(value: string) {
    this.motivoInclusao = value
  }

  @Mutation
  setObservacao(value: string) {
    this.observacao = value
  }

  @Mutation
  setUrgente(value: boolean) {
    this.urgente = !!value
  }

  @Mutation
  setExcelRepasse(value: any) {
    this.excelRepasse = value
  }

  @Mutation
  setNumeroAtendimento(value: string) {
    this.numeroAtendimento = value
  }

  @Mutation
  setHisProcedimento(value: string) {
    this.hisProcedimento = value
  }

  @Mutation
  setDataAtendimento(value: string) {
    this.dataAtendimento = value
  }

  @Mutation
  setCodigoItens(value: string) {
    this.codigoItens = value
  }

  @Mutation
  setItemAvulsoRepasse(value: any) {
    this.itemAvulsoRepasse = value
  }

  @Mutation
  setCodigoProcedimentoId(value: string) {
    this.codigoProcedimentoId = value
  }

  @Mutation
  setCentroDeCustoId(value: string) {
    this.centroDeCustoId = value
  }

  @Mutation
  setTransacaoFinanceiraId(value: string) {
    this.transacaoFinanceiraId = value
  }

  @Mutation
  setValorProcedimento(value: number) {
    this.valorProcedimento = value
  }

  @Mutation
  setQuantidade(value: number) {
    this.quantidade = value
  }

  @Mutation
  setNomePaciente(value: string) {
    this.nomePaciente = value
  }

  @Mutation
  setNumeroConta(value: string) {
    this.numeroConta = value
  }

  @Mutation
  setSeqProcedimentoHis(value: string) {
    this.seqProcedimentoHis = value
  }

  @Mutation
  setPontuacaoProfissional(value: any) {
    this.pontuacaoProfissional = value
  }

  @Mutation
  setTaxaAdm(value: any) {
    this.taxaAdm = value
  }

  @Mutation
  setValorDeReferencia(value: any) {
    this.valorDeReferencia = value
  }

  @Mutation
  setEmitirRelatorioEmLote(value: string[]) {
    this.emitirRelatorioEmLote = value
  }

  @Mutation
  setAplicarFatorAcomodacao(value: any) {
    this.aplicarFatorAcomodacao = value
  }

  @Mutation
  setIndiceAtualRegras(value: any) {
    this.indiceAtualRegras = value
  }

  @Mutation
  setTabelaReferencia(value: any) {
    this.tabelaReferencia = value
  }

  @Mutation
  setTabelaIndice(value: any) {
    this.tabelaIndice = value
  }

  @Mutation
  setItemsTabelaValidacaoTotal(total: number) {
    this.itemsTabelaValidacaoTotal = total
  }

  @Mutation
  setTotalGeracaoDeRepasseVisualizar(total: number) {
    this.totalGeracaoDeRepasseVisualizar = total
  }

  @Mutation
  setTotalProcedimentosDescartados(total: number) {
    this.totalProcedimentosDescartados = total
  }

  @Mutation
  clearAgrupamentoRepasse() {
    this.agrupamentoRepasse = { ...this.agrupamentoRepasseDefault }
  }

  @Mutation
  setGerarRepassePrestadores(value: any[]) {
    this.gerarRepassePrestadores = value
  }

  @Mutation
  setStatusList(value: any[]) {
    this.statusList = value
  }

  @Mutation
  setSelectedPrestador(value: any) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedTipo(value: any[]) {
    if (this.selectedTipo.includes(value)) {
      this.selectedTipo.splice(this.selectedTipo.indexOf(value), 1)
    } else {
      this.selectedTipo.push(value)
    }
  }

  @Mutation
  setSelectedStatus(value: any[]) {
    if (this.selectedStatus.includes(value)) {
      this.selectedStatus.splice(this.selectedStatus.indexOf(value), 1)
    } else {
      this.selectedStatus.push(value)
    }
  }

  @Mutation
  setFontePagadora(value: any[]) {
    this.fontePagadoras = value
  }

  @Mutation
  setCondicaoPagamento(value: any[]) {
    this.condicoesPagamento = value
  }

  @Mutation
  setFontePagadoraId(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setGrupoRepasseId(value: string) {
    this.grupoRepasseId = value
  }

  @Mutation
  setFontePagadoraIdExportarRegistros(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setSituacoesExportarRegistros(value: string) {
    this.situacoesExportarRegistros = value
  }

  @Mutation
  setFontePagadoraIdFinalizarProcessos(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setFontePagadoraGerarRepasse(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setEstabelecimentoGerarRepasse(value: string) {
    this.estabelecimentoGerarRepasseId = value
  }

  @Mutation
  setPrestadorGerarRepasse(value: string) {
    this.prestadorGerarRepasse = value
  }

  @Mutation
  setCondicaoPagamentoGerarRepasseId(value: string) {
    this.condicaoPagamentoGerarRepasseId = value
  }

  @Mutation
  setGrupoRepasseExportarRegistros(value: string) {
    this.grupoRepasse = value
  }

  @Mutation
  setGrupoRepasseFinalizarProcessos(value: string) {
    this.grupoRepasseFinalizarProcessos = value
  }

  @Mutation
  setLayoutRelatorio(value: boolean | null) {
    this.layoutRelatorio = value
  }

  @Mutation
  clearLayoutRelatorio() {
    this.layoutRelatorio = null
  }

  @Mutation
  setNumeroChamado(value: string) {
    this.numeroChamado = value
  }

  @Mutation
  setEmail(value: string) {
    this.email = value
  }

  @Mutation
  setNumeroRepasse(value: string) {
    this.numeroRepasse = value
  }

  @Mutation
  setContasPagar(value: string) {
    this.contasPagar = value
  }

  @Mutation
  setNumeroNota(value: string) {
    this.numeroNota = value
  }

  @Mutation
  setValorNota(value: string) {
    this.valorNota = value
  }

  @Mutation
  setCodigoRepasse(value: string) {
    this.codigoRepasse = value
  }

  @Mutation
  setPodeEncerrarRepasses(value: boolean) {
    this.enablePodeEncerrarRepasses = value
  }

  @Mutation
  setExibirOpcaoRelatorioAssinaturaDiretoria(value: boolean) {
    this.exibirOpcaoRelatorioAssinaturaDiretoria = value
  }

  @Mutation
  setSomatorioTotalNotas(value: number) {
    this.somatorioTotalNotas = value
  }

  @Mutation
  setGrupoRepasse(value: string) {
    this.grupoRepasse = value
  }

  @Mutation
  setAnoMesReferencia(value: string) {
    this.anoMesReferencia = value
  }

  @Mutation
  setAnoMesReferenciaDe(value: string) {
    this.anoMesReferenciaDe = value
  }

  @Mutation
  setAnoMesReferenciaAte(value: string) {
    this.anoMesReferenciaAte = value
  }

  @Mutation
  setCompetenciaFaturamento(value: string) {
    this.competenciaFaturamentoAnoMes = value
  }

  @Mutation
  setCompetenciaRepasse(value: string) {
    this.competenciaRepasseAnoMes = value
  }

  @Mutation
  setAnoMesReferenciaListaRepasse(value: string) {
    this.anoMesReferenciaListaRepasse = value
  }

  @Mutation
  setAnoMesReferenciaExportarRegistros(value: string) {
    this.anoMesReferenciaExportarRegistros = value
  }

  @Mutation
  setRelatorioSelected(value: string) {
    this.relatorioSelected = value
  }

  @Mutation
  setAnoMesReferenciaFinalizarProcessos(value: string) {
    this.anoMesReferenciaFinalizarProcessos = value
  }

  @Mutation
  setAnoMesReferenciaGeracaoRepasse(value: string) {
    this.anoMesReferenciaGeracaoRepasse = value
  }

  @Mutation
  setAnoMesReferenciaDoRepasse(value: string) {
    this.anoMesReferenciaDoRepasse = value
  }

  @Mutation
  setDataEnvioNotaFiscalGeracaoRepasse(value: string) {
    this.dataEnvioNotaFiscalGeracaoRepasse = value
  }

  @Mutation
  setDataVencimentoGeracaoRepasse(value: string) {
    this.dataVencimentoGeracaoRepasse = value
  }

  @Mutation
  setAnoMesReferenciaRecalcularValores(value: string) {
    this.anoMesReferenciaRecalcularValores = value
  }

  @Mutation
  setPrazoRecalcularValores(value: string) {
    this.prazoRecalcularValores = value
  }

  @Mutation
  setDataRecebimentoRecalcularValores(value: string) {
    this.dataRecebimentoRecalcularValores = value
  }

  @Mutation
  setAluguelPrestadorId(value: string) {
    this.aluguelPrestadorId = value
  }

  @Mutation
  setModal(modal: { name: string; value: any; context?: string }) {
    this.modal[modal.name] = modal.value
    this.modalContext = modal.context || null
  }

  @Mutation
  setDisabledConfirmar(value: boolean) {
    this.disabledConfirmar = value
  }

  @Mutation
  setIsNewNotaFiscal(value: boolean) {
    this.isNewNotaFiscal = value
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  setFuncoes(value: string) {
    if (this.funcoes.includes(value)) {
      this.funcoes.splice(this.funcoes.indexOf(value), 1)
    } else {
      this.funcoes.push(value)
    }
  }

  @Mutation
  setStatusGeracaoRepasse(value: string) {
    if (this.statusGeracaoRepasse.includes(value)) {
      this.statusGeracaoRepasse.splice(this.statusGeracaoRepasse.indexOf(value), 1)
    } else {
      this.statusGeracaoRepasse.push(value)
    }
  }

  @Mutation
  setFontePagadoraFilter(value: string) {
    this.fontePagadoraFilter = value
  }

  @Mutation
  setTipoItens(value: string) {
    this.tipoItens = value
  }

  @Mutation
  setApenasDivergentes(value: boolean) {
    this.apenasDivergente = value
  }

  @Mutation
  setAlterarFuncao(value: string) {
    this.alterarFuncao = value
  }

  @Mutation
  clearAlterarFuncao() {
    this.alterarFuncao = ''
  }

  @Mutation
  setSituacoesValidacao(value: string) {
    if (this.situacoesValidacao.includes(value)) {
      this.situacoesValidacao.splice(this.situacoesValidacao.indexOf(value), 1)
    } else {
      this.situacoesValidacao.push(value)
    }
  }

  @Mutation
  setErrosValidacao(value: string) {
    if (this.errosValidacao.includes(value)) {
      this.errosValidacao.splice(this.errosValidacao.indexOf(value), 1)
    } else {
      this.errosValidacao.push(value)
    }
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setSearchCodigo(value: string) {
    this.searchCodigo = value
  }

  @Mutation
  setSearchDescricao(value: string) {
    this.searchDescricao = value
  }

  @Mutation
  setTabelaPropria(value: string) {
    this.tabelaPropria = value
  }

  @Mutation
  setSearchCodigoDebounce(value: string) {
    this.searchCodigoDebounce = value
  }

  @Mutation
  setSearchDescricaoDebounce(value: string) {
    this.searchDescricaoDebounce = value
  }

  @Mutation
  setPrestadoresRecebimentos(value: PrestadorRecebimento[]) {
    this.prestadoresRecebimentos = value
  }

  @Mutation
  setListaColunasOcultar(value: any[]) {
    this.colunasOcultarItems = value
  }

  @Mutation
  setGeracaoDeRepassesItems(value: any[]) {
    this.geracaoDeRepassesItems = value
  }

  @Mutation
  setPrestadorId(value: any) {
    this.prestadorId = value
  }

  @Mutation
  setProfissionalRepasse(value: any) {
    this.profissionalRepasse = value
  }

  @Mutation
  setMedicoRecebimentoId(value: any) {
    this.medicoRecebimentoIds = value
  }

  @Mutation
  setGeracaoDeRepassesItemsVisualizar(value: any[]) {
    this.geracaoDeRepassesItemsVisualizar = value
  }

  @Mutation
  setProcedimentosDescartados(value: any[]) {
    this.procedimentosDescartados = value
  }

  @Mutation
  setCargasVisualizarItems(value: any[]) {
    this.cargasVisualizarItems = value
  }

  @Mutation
  setAcoesGeracaoRepasse(value: any) {
    this.acoesGeracaoRepasse = value
  }

  @Mutation
  setDadosGeraisDoRepasse(value: any) {
    this.dadosGeraisDoRepasse = value
  }

  @Mutation
  setGeracaoDeRepassesItemsPrestador(value: any[]) {
    this.geracaoDeRepassesItemsPrestador = value
  }

  @Mutation
  setDescontosPrestador(value: any[]) {
    this.descontosPrestador = value
  }

  @Mutation
  deleteItemsFromGeracaoDeRepassesItemsPrestador(medicoRecebimentoIds: string[]) {
    medicoRecebimentoIds.forEach((id: string) => {
      const index = this.geracaoDeRepassesItemsPrestador.findIndex((item: any) => item.medicoRecebimentoId === id)
      if (index !== -1) {
        this.geracaoDeRepassesItemsPrestador.splice(index, 1)
      }
    })
  }

  @Mutation
  setPontuacoes(value: any[]) {
    this.pontuacoes = value
  }

  @Mutation
  setProcedimentos(value: any[]) {
    this.codigoProcedimento = value
  }

  @Mutation
  clearProcedimentos() {
    this.codigoProcedimento = [...this.codigoProcedimentoDefault]
  }

  @Mutation
  setTransacaoFinanceira(value: any[]) {
    this.transacaoFinanceira = value
  }

  @Mutation
  clearTransacaoFinanceira() {
    this.transacaoFinanceira = [...this.transacaoFiananceiraDefault]
  }

  @Mutation
  setCentroDeCusto(value: any[]) {
    this.centroDeCusto = value
  }

  @Mutation
  clearCentroDeCusto() {
    this.centroDeCusto = [...this.centroDeCustoDefault]
  }

  @Mutation
  setItemsCargaRemuneracao(value: ItemsCargaRemuneracao[]) {
    this.itemsCargaRemuneracao = value
  }

  @Mutation
  setItemsDownloadNotasFiscais(value: any[]) {
    this.itemsDownloadNotasFiscais = value
  }

  @Mutation
  setTotalItemsDownloadNotasFiscais(value: number) {
    this.totalItemsDownloadNotasFiscais = value
  }

  @Mutation
  setTabelasDeReferencia(value: TabelasDeReferencia[]) {
    this.tabelasDeReferencia = value
  }

  @Mutation
  setItemsRecebimentoMonitor(value: any) {
    this.itensRecebimentoMonitor = value
  }

  @Mutation
  setRepassesCarregados(value: any) {
    this.repassesCarregados = value
  }

  @Mutation
  setTotalItensRepassesCarregados(value: any) {
    this.totalItensRepassesCarregados = value
  }

  @Mutation
  setItensRecebimentoErros(value: any) {
    this.itensRecebimentoErros = value
  }

  @Mutation
  setBackofficeProducao(value: BackofficeProducao[]) {
    this.backofficeProducao = value
  }

  @Mutation
  setCargaLogs(logs: CargaRemuneracaoLog[]) {
    this.cargaLogs = logs
  }

  @Mutation
  setPrestadorRecebimento(value: PrestadorRecebimento) {
    this.prestadorRecebimento = value
  }

  @Mutation
  setDocumentoId(value: any) {
    this.documentoId = value
  }

  @Mutation
  setNotaFiscalUnica(value: any) {
    this.notaFiscalUnica = value
  }

  @Mutation
  setBackofficeProcedimentos(value: Procedimentos[]) {
    this.backofficeProcedimentos = value
  }

  @Mutation
  setTemplateNotificarConfig(value: TemplateNotificarConfig) {
    this.templateNotificarConfig = value
  }

  @Mutation
  clearPrestadoresRecebimentos() {
    this.prestadoresRecebimentos = [...this.prestadoresRecebimentosDefault]
  }

  @Mutation
  clearPrestadorRecebimento() {
    this.prestadorRecebimento = { ...this.prestadorRecebimentoDefault }
  }

  @Mutation
  clearTemplateNotificarConfig() {
    this.templateNotificarConfig = { ...this.templateNotificarConfigDefault }
  }

  @Mutation
  clearSituacoes() {
    this.situacoes = []
  }

  @Mutation
  clearFuncoes() {
    this.funcoes = []
  }

  @Mutation
  clearAdvancedFilters() {
    this.numeroAtendimento = ''
    this.codigoItens = ''
    this.tipoItens = ''
    this.convenios = ''
    this.profissionais = ''
    this.anoMesReferenciaDe = ''
    this.anoMesReferenciaAte = ''
  }

  @Mutation
  clearProcedimentosDescartadosFilter() {
    this.numeroAtendimento = ''
    this.codigoItens = ''
    this.hisProcedimento = ''
    this.selectedPrestador = ''
    this.anoMesReferenciaDe = ''
    this.anoMesReferenciaAte = ''
    this.profissionais = ''
    this.convenios = ''
  }

  @Mutation
  clearFilterValidacaoEGeracaoRepasse() {
    this.selectedStatus = []
    this.selectedPrestador = ''
  }

  @Mutation
  clearFilterGeracaoRepasse() {
    this.selectedTipo = []
    this.anoMesReferencia = ''
  }

  @Mutation
  clearSearch() {
    this.search = ''
  }

  @Mutation
  clearSearchCodigo() {
    this.searchCodigo = ''
  }

  @Mutation
  setSituacoesCount(situacoes: any) {
    this.situacoesFiltro = situacoes
  }

  @Mutation
  setFuncoesFiltro(funcoes: any) {
    this.funcoesFiltro = funcoes.map((f: any) => f.funcao)
  }

  @Mutation
  setTiposCarga(data: any[]) {
    this.tiposCarga = data
  }

  @Mutation
  setTipoCargaSelected(data: string) {
    this.tipoCargaSelected = data
  }

  @Mutation
  setPagina(pag: number) {
    this.pagina = pag
  }

  @Mutation
  setPaginaRepassesCarregados(pag: number) {
    this.paginaRepassesCarregados = pag
  }

  @Mutation
  setPaginaGeracao(pag: number) {
    this.paginaGeracao = pag
  }

  @Mutation
  setIdForLoadValidacaoEGeracaoRepasse(id: string) {
    this.idForLoadValidacaoEGeracaoRepasse = id
  }

  @Mutation
  setIdForCloseGeracao(id: string) {
    this.idForCloseGeracao = id
  }

  @Mutation
  setIdForLoadProcedimentosDescartados(id: string) {
    this.idForLoadProcedimentosDescartados = id
  }

  @Mutation
  podeLiberarRepasse(value: string) {
    this.podeLiberar = value
  }

  @Mutation
  podeDescartarRepasse(value: boolean) {
    this.podeDescartar = value
  }

  @Mutation
  setIdForLoadItensRepasse(id: string) {
    this.idForLoadItensRepasse = id
  }

  @Mutation
  setIdForLoadPrestadores(id: string) {
    this.idForLoadPrestadores = id
  }

  @Mutation
  setPrestadorRecebimentoId(id: string) {
    this.prestadorRecebimentoId = id
  }

  @Mutation
  setStatusGeracaoDeRepasse(status: string) {
    this.statusGeracaoDeRepasse = status
  }

  @Mutation
  setIdForLoadItemAvulso(id: string) {
    this.idForLoadItemAvulso = id
  }

  @Mutation
  setPageItems(pag: number) {
    this.pageItems = pag
  }

  @Mutation
  setPaginaProducao(pag: number) {
    this.paginaProducao = pag
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  fillAllSituacoes() {
    this.situacoes = [
      'Pendente',
      'Divergente',
      'ValidacaoPendente',
      'Validada',
      'Paga',
      'Provisionada',
      'EnviadoParaPagamento',
    ]
  }

  @Mutation
  setTotalPrestadorRemuneracao(total: number) {
    this.totalPrestadorRemuneracao = total
  }

  @Mutation
  setExibirNumeroChamado(total: boolean) {
    this.exibirNumeroChamado = total
  }

  @Mutation
  setTotalGeracaoDeRepasse(total: number) {
    this.totalGeracaoDeRepasse = total
  }

  @Mutation
  setTipoEnum(value: any) {
    this.tipoEnum = value
  }

  @Mutation
  setTotalItensPrestador(total: number) {
    this.totalItensPrestador = total
  }

  @Mutation
  setValorTotal(total: number) {
    this.valorTotal = total
  }

  @Mutation
  setQuantidadeTotal(total: number) {
    this.quantidadeTotal = total
  }

  @Mutation
  setTotalItemsCargaRemuneracao(total: number) {
    this.totalItemsCargaRemuneracao = total
  }

  @Mutation
  setProfissionaisExecutantes(value: any[]) {
    this.profissionaisExecutantes = value
    this.profissionaisList = value
  }

  @Mutation
  setTipoItensList(value: any[]) {
    this.tipoItensList = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setStatusGeracaoRepasseFiltro(value: any[]) {
    this.statusGeracaoRepasseFiltro = value
  }

  @Mutation
  setFuncoesProfissionalExecutante(value: any[]) {
    this.funcoesProfissionalExecutante = value
  }

  @Mutation
  setConveniosRepasse(value: any[]) {
    this.conveniosRepasse = value
    this.conveniosList = value
  }

  @Mutation
  setPlanosRepasse(value: any[]) {
    this.planosRepasse = value
  }

  @Mutation
  setViasAcesso(value: any[]) {
    this.viasAcesso = value
  }

  @Mutation
  clearProfissionaisExecutantes() {
    this.profissionaisExecutantes = [...this.profissionaisExecutantesDefault]
  }

  @Mutation
  clearPrestadoresRepasse() {
    this.prestadoresRepasse = []
  }

  clearFuncoesProfissionalExecutante() {
    this.funcoesProfissionalExecutante = []
  }

  @Mutation
  clearConveniosRepasse() {
    this.conveniosRepasse = []
  }

  @Mutation
  clearPlanosRepasse() {
    this.planosRepasse = []
  }

  @Mutation
  clearViasAcesso() {
    this.viasAcesso = []
  }

  @Mutation
  setMotivosInclusao(value: any[]) {
    this.motivosInclusaoItemAvulso = value
  }

  @Mutation
  clearMotivosInclusao() {
    this.motivosInclusaoItemAvulso = [...this.motivosInclusaoItemAvulsoDefault]
  }

  @Mutation
  setConvenio(value: any) {
    this.convenio = value
  }

  @Mutation
  setProfissionais(value: any) {
    this.profissionais = value
  }

  @Mutation
  setConvenios(value: any) {
    this.convenios = value
  }

  @Mutation
  setOperadoraId(value: any) {
    this.operadoraId = value
  }

  @Mutation
  setTabelaId(value: any) {
    this.tabelaId = value
  }

  @Mutation
  setItemUpdateId(value: any) {
    this.itemUpdateId = value
  }

  @Mutation
  setProfissionalRegrasId(value: any) {
    this.profissionalRegrasId = value
  }

  @Mutation
  setFontePagadoraRegrasId(value: any) {
    this.fontePagadoraRegrasId = value
  }

  @Mutation
  setCodigoTuss(value: any) {
    this.codigoTuss = value
  }

  @Mutation
  setCodigoAMB(value: any) {
    this.codigoAMB = value
  }

  @Mutation
  setMedicoProducaoProcedimentoId(value: any) {
    this.medicoProducaoProcedimentoId = value
  }

  @Mutation
  setDescricaoTuss(value: any) {
    this.descricaoTuss = value
  }

  @Mutation
  setTabelaAmbId(value: any) {
    this.tabelaAmbId = value
  }

  @Mutation
  setTotalItensDoRepasse(total: number) {
    this.totalRepasseItems = total
  }

  @Mutation
  setItemsId(value: string) {
    this.itemsId = value
  }

  @Mutation
  setTotalTabelaDeReferencia(total: number) {
    this.totalTabelaDeReferencia = total
  }

  @Mutation
  setTotalBackofficeProducao(total: number) {
    this.totalBackofficeProducao = total
  }

  @Mutation
  setTotalPageBackofficeProducao(total: number) {
    this.totalPageBackofficeProducao = total
  }

  @Mutation
  clearDocumento() {
    this.prestadorRecebimento.nomeArquivoOriginal = ''
  }

  @Mutation
  setNomeArquivoOriginal(nome: string) {
    this.prestadorRecebimento.nomeArquivoOriginal = nome
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  clearGeracaoRepasses() {
    this.fontePagadoraId = ''
    this.condicaoPagamentoGerarRepasseId = ''
    this.anoMesReferenciaGeracaoRepasse = ''
    this.dataVencimentoGeracaoRepasse = ''
    this.dataEnvioNotaFiscalGeracaoRepasse = ''
    this.estabelecimentoGerarRepasseId = ''
    this.prestadorGerarRepasse = ''
    this.anoMesReferenciaDoRepasse = ''
  }

  @Mutation
  clearFiltro() {
    this.grupoRepasse = ''
    this.anoMesReferencia = ''
    this.fontePagadoraId = ''
    this.numeroChamado = ''
    this.numeroRepasse = ''
    this.numeroNota = ''
    this.valorNota = ''
    this.contasPagar = ''
  }

  @Mutation
  clearFiltroValidacao() {
    this.codigoTuss = ''
    this.competenciaFaturamentoAnoMes = ''
    this.fontePagadoraId = ''
  }

  @Mutation
  atualizaStatusParaProvisionada(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.situacao.display = SituacaoRemuneracaoEnum.Provisionada
        temp.situacao.key = SituacaoRemuneracaoEnum.Provisionada
        temp.acoes.podeProvisionar = false
        temp.acoes.atualizar = false
        temp.acoes.podeCancelarProvisionamento = true
        temp.acoes.podeDeletarNotaFiscal = false
        temp.acoes.visualizar = false
      }
      return temp
    })
  }

  @Mutation
  atualizaStatusParaPendente(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.situacao.display = SituacaoRemuneracaoEnum.Pendente
        temp.situacao.key = SituacaoRemuneracaoEnum.Pendente
        temp.acoes.podeProvisionar = true
        temp.acoes.atualizar = true
        temp.acoes.podeCancelarProvisionamento = false
        temp.acoes.podeDeletarNotaFiscal = false
        temp.acoes.visualizar = false
      }
      return temp
    })
  }

  @Mutation
  atualizaDataPrevisaoPagamento(params: any) {
    const index = this.prestadoresRecebimentos.findIndex((e: any) => e.id === params.prestadorRecebimentoId)
    this.prestadoresRecebimentos[index].dataPrevisaoPagamento = params.novaPrevisaoRecebimento
  }

  @Mutation
  atualizarAcaoPodeProvisionar(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.acoes.podeProvisionar = true
      }
      return temp
    })
  }

  @Mutation
  atualizarDataNotificacao(params: any) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === params.prestadorRecebimentoId) {
        temp.dataUltimaNotificacao = params.dataNotificacaoManual
      }
      return temp
    })
  }

  @Mutation
  setGrupoRepasseItens(itens: any[]) {
    this.grupoRepasseItens = itens
  }

  @Mutation
  setItemsMonitoramentoCargas(value: any[]) {
    this.itemsMonitoramentoCargas = value
  }

  @Mutation
  setTipoFilter(value: any) {
    this.tipoFilter = value
  }

  @Mutation
  setTotalItemsMonitoramentoCargas(value: number) {
    this.totalItemsMonitoramentoCargas = value
  }

  @Mutation
  setItemRepasse(item: any) {
    this.itemRepasse = item
  }

  @Mutation
  setGrupoRepasseItensAll(itens: any[]) {
    this.grupoRepasseItensAll = itens
  }

  @Mutation
  setPrestadoresLista(value: PrestadoresRecebimentoSearch[]) {
    this.prestadoresLista = value
  }

  @Mutation
  setImpostoPrestadorList(value: any[]) {
    this.impostoPrestadorList = value
  }

  @Mutation
  setIdForSaveAlterarPrestador(value: string) {
    this.idForSaveAlterarPrestador = value
  }

  @Mutation
  setIdDesfazerRepasse(value: string) {
    this.idForDesfazerRepasse = value
  }

  @Mutation
  clearPrestadoresLista() {
    this.prestadoresLista = [...this.prestadoresListaDefault]
  }

  @Mutation
  setMensagemLogDesfazer(value: string) {
    this.mensagemLogDesfazer = value
  }

  @Mutation
  clearDownloadNotas() {
    this.fontePagadoraIdDownloadNotasFiscais = ''
    this.anoMesReferenciaDownloadNotasFiscais = ''
    this.situacoesDoRepasseDownloadNotasFiscais = ''
    this.grupoRepasseDownloadNotasFiscais = ''
    this.createdOnNFDe = ''
    this.createdOnNFAte = ''
  }

  @Action
  async downloadArquivosCargaRemuneracao(id: string) {
    try {
      const response = await this.remuneracaoMedica.downloadArquivosCargaRemuneracao(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async downloadCargasGeracao(id: string) {
    try {
      const response = await this.remuneracaoMedica.downloadCargasGeracao(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getRepassesCarregados(id: string) {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      importacaoArquivoId: id,
    }
    try {
      const response = await this.remuneracaoMedica.getRepassesCarregados(params)
      if (response.success) {
        this.context.commit('setRepassesCarregados', response.data.itens)
        this.context.commit('setTotalItensRepassesCarregados', response.data.totalRegistros)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRecebimentoMonitor(recebimentoId: string) {
    try {
      const response = await this.remuneracaoMedica.getItemsRecebimentoMonitor(recebimentoId)
      if (response.success) {
        this.context.commit('setItemsRecebimentoMonitor', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRecebimentoErros(recebimentoId: string) {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        recebimentoId,
      }
      const response = await this.remuneracaoMedica.getItemsRecebimentoErros(params)
      if (response.success) {
        this.context.commit('setItensRecebimentoErros', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelasDeReferencia() {
    const response = await this.remuneracaoMedica.getTabelasDeReferencia()
    if (response.success) {
      this.context.commit('setTabelasDeReferencia', response.data)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.length })
      this.context.commit('setTotalTabelaDeReferencia', response.data.length)
    }

    return response
  }

  @Action
  async criarTabelaPreco() {
    try {
      const params: any = {
        nome: this.nome,
      }
      const response = await this.remuneracaoMedica.criarTabelaPreco(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getBackofficeProducao() {
    const params: any = {
      pagina: this.paginaProducao,
      qtdPorPagina: this.qtdPorPagina,
      filtroTexto: this.buscaProducao,
    }

    const response = await this.remuneracaoMedica.getBackofficeProducao(params)
    if (response.success) {
      this.context.commit('setBackofficeProducao', response.data.producoes)
      this.context.commit('setTotalBackofficeProducao', response.data.totalRegistros)
      this.context.commit('setTotalPageBackofficeProducao', response.data.totalPaginas)
      const procedimentos = response.data.procedimentos
        ? response.data.procedimentos
        : []
      this.context.commit('setBackofficeProcedimentos', procedimentos)
    }

    return response
  }

  @Action
  async getItemsCargaRemuneracaoAll() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      sortBy: this.sortBy,
    }

    const response = await this.remuneracaoMedica.getItemsCargaRemuneracaoAll(params)
    if (response.success) {
      this.context.commit('setItemsCargaRemuneracao', response.data.arquivos)
      this.context.commit('setTiposCarga', response.data.tiposCarga)
      this.context.commit('setTotalItemsCargaRemuneracao', response.data.totalRegistros)
    }
    return this.itemsCargaRemuneracao
  }

  @Action
  async getItemsDownloadNotasFiscais() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }

    const response = await this.remuneracaoMedica.getItemsDownloadNotasFiscais(params)
    if (response.success) {
      this.context.commit('setItemsDownloadNotasFiscais', response.data.itens)
      this.context.commit('setTotalItemsDownloadNotasFiscais', response.data.totalRegistros)
    }
    return this.itemsCargaRemuneracao
  }

  @Action
  async desfazerRepasse() {
    try {
      const params: any = {
        importacaoArquivoId: this.idForDesfazerRepasse,
      }

      const response = await this.remuneracaoMedica.desfazerRepasse(params)
      this.context.commit('setMensagemLogDesfazer', response.data)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getPrestadorRemuneracaoAll() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      situacoes: this.situacoes,
      grupoRepasse: this.grupoRepasse,
      anoMesReferencia: this.anoMesReferencia,
      fontePagadoraId: this.fontePagadoraId,
      numeroChamado: this.numeroChamado,
      numeroRepasse: this.numeroRepasse,
      somatorioTotalNotas: this.somatorioTotalNotasDefault,
      contasPagar: this.contasPagar,
      valornota: this.valorNota,
      numeroNota: this.numeroNota,
      sortBy: this.sortBy,
      nome: this.nomePrestador,
    }

    const response = await this.remuneracaoMedica.getPrestadorRecebimentoAll(params)
    if (response.success) {
      this.context.commit('setPrestadoresRecebimentos', response.data.remuneracoes)
      this.context.commit('setListaColunasOcultar', response.data.listaColunasOcultar)
      this.context.commit('setSituacoesCount', response.data.situacoes)
      this.context.commit('setTotalPrestadorRemuneracao', response.data.total)
      this.context.commit('setExibirNumeroChamado', response.data.exibirNumeroChamado)
      this.context.commit('setGrupoRepasseItens', response.data.gruposRepasse)
      this.context.commit('setExibirOpcaoRelatorioAssinaturaDiretoria', response.data.exibirOpcaoRelatorioAssinaturaDiretoria)
      this.context.commit('setPodeEncerrarRepasses', response.data.podeEncerrarRepasses)
    }

    return this.prestadoresRecebimentos
  }

  @Action
  async getTiposCarga() {
    try {
      const response = await this.remuneracaoMedica.getTiposCarga()
      if (response.success) {
        this.context.commit('setTiposCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsMonitoramentoCargas() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        tipoEnum: this.search,
      }

      const request = await this.remuneracaoMedica.getItemsMonitoramentoCargas(params)

      if (request.success) {
        this.context.commit('setItemsMonitoramentoCargas', request.data.itens)
        this.context.commit('setTotalItemsMonitoramentoCargas', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsMonitoramentoCargas', [])
      return { success: false, message: error }
    }
  }

  @Action
  async getTipoFilter() {
    try {
      const response = await this.remuneracaoMedica.getTipoFilter()
      if (response.success) {
        this.context.commit('setTipoFilter', response.data)
      }

      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getTiposCargaDownload() {
    try {
      const response = await this.remuneracaoMedica.getTiposCargaDownload()
      if (response.success) {
        this.context.commit('setTiposCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async alterarSituacoesEmLote() {
    try {
      const params: any = {
        grupoRepasseId: this.grupoRepasseFinalizarProcessos || null,
        anoMesReferencia: this.anoMesReferenciaFinalizarProcessos ? `${this.anoMesReferenciaFinalizarProcessos}-01` : null,
        fontePagadoraId: this.fontePagadoraId || null,
      }
      const response = await this.remuneracaoMedica.alterarSituacoesEmLote(params)
      if (response.success) this.context.commit('setFinalizarProcessos', response.data)
      return response
    } catch (error) {
      return { message: 'Não foi finalizar os repasses.' }
    }
  }

  @Action
  async saveAluguelPrestador() {
    try {
      const params: any = {
        prestadorId: this.idForSaveAlterarPrestador,
        tipo: this.tipoAluguelPrestador,
        valor: this.valorAluguelPrestador === undefined ? 0 : +this.valorAluguelPrestador,
      }
      const request = await this.remuneracaoMedica.saveAluguelPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveAlterarPontuacaoProfissional() {
    const params: any = {
      profissionalId: this.profissionalPontuacao,
      pontuacaoId: this.pontuacaoProfissional,
    }
    const response = await this.remuneracaoMedica.saveAlterarPontuacaoProfissional(params)
    return response
  }

  @Action
  async saveNovoItemAvulsoRepasse() {
    try {
      const procedimento: any = this.codigoProcedimento.find((e: any) => e.id === this.codigoProcedimentoId)
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItemAvulso,
        valor: this.valorProcedimento === undefined ? 0 : +this.valorProcedimento,
        turno: null,
        profissionalExecutanteId: this.profissionalPontuacao || null,
        codigoProcedimento: procedimento ? procedimento.codigo : null,
        descricaoProcedimento: procedimento ? procedimento.descricao : null,
        nomePaciente: this.nomePaciente,
        dataRealizacao: `${new Date(this.dataAtendimento).toISOString().split('T')[0]}T00:00:00`,
        numeroConta: this.numeroConta,
        identificadorHisProducaoProcedimento: this.seqProcedimentoHis,
        quantidade: this.quantidade,
        convenioId: this.convenioRepasse || null,
        planoId: this.planoRepasse || null,
        viaAcesso: this.viaAcesso || null,
        funcao: this.funcaoProfissionalExecutante || null,
        numeroAtendimento: this.numeroAtendimento,
        observacao: this.observacao,
        urgente: this.urgente,
        transacaoFinanceiraId: this.transacaoFinanceiraId || null,
        centroDeCustoId: this.centroDeCustoId || null,
        motivoInclusaoAvulsoId: this.motivoInclusao || null,
      }
      const response = await this.remuneracaoMedica.saveNovoItemAvulsoRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveInsercaoDeRegistrosEmLoteCalcularRepasse({ formData, context }) {
    try {
      const formDataToSend = new FormData()

      formDataToSend.append('anexo', formData)
      formDataToSend.append('geracaoRepasseId', this.idForLoadValidacaoEGeracaoRepasse)
      formDataToSend.append('prestadorRecebimentoId', context === 'cargaGeracao' ? String(null) : String(this.idForLoadItemAvulso))
      formDataToSend.append('transacaoFinanceiraId', this.transacaoFinanceiraId || '')
      formDataToSend.append('centroDeCustoId', this.centroDeCustoId || '')
      formDataToSend.append('motivoInclusaoId', this.motivoInclusao || '')
      formDataToSend.append('observacao', this.observacao)
      formDataToSend.append('tipo', 'GeracaoRepasseCargaProducaoProcedimento')

      const response = await this.remuneracaoMedica.saveInsercaoDeRegistrosEmLoteCalcularRepasse(formDataToSend)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveItensFixosCargaPlanilha({ formData, context }) {
    try {
      const formDataToSend = new FormData()

      formDataToSend.append('anexo', formData)
      formDataToSend.append('geracaoRepasseId', this.idForLoadValidacaoEGeracaoRepasse)
      formDataToSend.append('prestadorRecebimentoId', context === 'cargaGeracao' ? String(null) : String(this.idForLoadItemAvulso))
      formDataToSend.append('transacaoFinanceiraId', this.transacaoFinanceiraId || '')
      formDataToSend.append('centroDeCustoId', this.centroDeCustoId || '')
      formDataToSend.append('motivoInclusaoId', this.motivoInclusao || '')
      formDataToSend.append('observacao', this.observacao)
      formDataToSend.append('tipo', 'GeracaoRepasseCargaProducaoProcedimentoFixo')

      const response = await this.remuneracaoMedica.saveInsercaoDeRegistrosEmLoteCalcularRepasse(formDataToSend)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveNovoItemAvulsoCalcularRepasse() {
    try {
      const procedimento: any = this.codigoProcedimento.find((e: any) => e.id === this.codigoProcedimentoId)
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItemAvulso,
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
        valor: this.valorProcedimento === undefined ? 0 : +this.valorProcedimento,
        turno: null,
        profissionalExecutanteId: this.profissionalPontuacao || null,
        codigoProcedimento: procedimento ? procedimento.codigo : null,
        descricaoProcedimento: procedimento ? procedimento.descricao : null,
        nomePaciente: this.nomePaciente,
        dataRealizacao: `${new Date(this.dataAtendimento).toISOString().split('T')[0]}T00:00:00`,
        codigoHisContaPaciente: this.numeroConta,
        identificadorHisProducaoProcedimento: this.seqProcedimentoHis,
        quantidade: this.quantidade,
        convenioId: this.convenioRepasse || null,
        planoId: this.planoRepasse || null,
        viaAcesso: this.viaAcesso || null,
        funcao: this.funcaoProfissionalExecutante || null,
        numeroAtendimento: this.numeroAtendimento,
        observacao: this.observacao,
        urgente: this.urgente,
        transacaoFinanceiraId: this.transacaoFinanceiraId || null,
        centroDeCustoId: this.centroDeCustoId || null,
        motivoInclusaoAvulsoId: this.motivoInclusao || null,
      }
      const response = await this.remuneracaoMedica.saveNovoItemAvulsoCalcularRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveAlterarPrestador() {
    try {
      const params: any = {
        profissionalExecutanteId: this.profissionalPontuacao,
        prestadorRecebimentoId: this.prestadorId,
        medicoRecebimentoIds: this.medicoRecebimentoIds,
        prestadorId: this.prestadorRepasse.prestadorId,
        contratoId: this.prestadorRepasse.contratoId,
      }
      const response = await this.remuneracaoMedica.saveAlterarPrestador(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getFontePagadoraAll() {
    const response = await this.remuneracaoMedica.getFontePagadoraAll()
    if (response.success) {
      this.context.commit('setFontePagadora', response.data)
    }

    return response
  }

  @Action
  async getTipoItens() {
    try {
      const request = await this.remuneracaoMedica.getTipoItens()
      if (request.success) {
        this.context.commit('setTipoItensList', request.success ? request.data : [])
      }
      return request
    } catch (error) {
      this.context.commit('setTipoItensList', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getGerarRepassePrestadores(param: any) {
    try {
      const response = await this.remuneracaoMedica.getGerarRepassePrestadores(param)
      if (response.success) {
        this.context.commit('setGerarRepassePrestadores', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getStatusList() {
    try {
      const response = await this.remuneracaoMedica.getStatusList()
      if (response.success) {
        this.context.commit('setStatusList', response.data)
      }
      return response
    } catch (error) {
      this.context.commit('setStatusList', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async gerarRepasses() {
    try {
      const params: any = {
        fontePagadoraId: this.fontePagadoraId || null,
        estabelecimentoId: this.estabelecimentoGerarRepasseId || null,
        prestadorId: this.prestadorGerarRepasse || null,
        condicaoPagamentoId: this.condicaoPagamentoGerarRepasseId || null,
        mesAnoCompetencia: this.anoMesReferenciaGeracaoRepasse ? `${this.anoMesReferenciaGeracaoRepasse}-01` : null,
        mesReferencia: this.anoMesReferenciaDoRepasse ? `${this.anoMesReferenciaDoRepasse}-01` : null,
        dataVencimento: this.dataVencimentoGeracaoRepasse || null,
        prazoEnvioNF: this.dataEnvioNotaFiscalGeracaoRepasse || null,
      }
      const response = await this.remuneracaoMedica.gerarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionais() {
    try {
      const request = await this.remuneracaoMedica.getProfissionais()
      this.context.commit('setProfissionaisExecutantes', request.success ? request.data.pessoas : [])
      return request
    } catch (error) {
      this.context.commit('setProfissionaisExecutantes', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPrestadoresRepasse() {
    try {
      const params: any = {
        fontePagadoraId: this.idForLoadPrestadores || null,
        profissionalId: this.profissionalRepasse || null,
      }
      const request = await this.remuneracaoMedica.getPrestadoresRepasse(params)
      this.context.commit('setPrestadoresRepasse', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setPrestadoresRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getFuncoesProfissionalExecutante() {
    try {
      const request = await this.remuneracaoMedica.getFuncoesProfissionalExecutante()
      this.context.commit('setFuncoesProfissionalExecutante', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setFuncoesProfissionalExecutante', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getConveniosRepasse() {
    const params: any = {
      nome: null,
    }
    try {
      const request = await this.remuneracaoMedica.getConveniosRepasse(params)
      this.context.commit('setConveniosRepasse', request.success ? request.data.convenios : [])
      return request
    } catch (error) {
      this.context.commit('setConveniosRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPlanosRepasse() {
    const params: any = {
      convenioId: this.convenioRepasse || null,
    }
    try {
      const request = await this.remuneracaoMedica.getPlanosRepasse(params)
      this.context.commit('setPlanosRepasse', request.success ? request.data.itens : [])
      return request
    } catch (error) {
      this.context.commit('setPlanosRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getViasAcesso() {
    try {
      const request = await this.remuneracaoMedica.getViasAcesso()
      this.context.commit('setViasAcesso', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setViasAcesso', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getMotivoInclusao() {
    try {
      const request = await this.remuneracaoMedica.getMotivoInclusao()
      this.context.commit('setMotivosInclusao', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setMotivosInclusao', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCondicaoPagamentoAll() {
    const response = await this.remuneracaoMedica.getCondicaoPagamento()
    if (response.success) {
      this.context.commit('setCondicaoPagamento', response.data.itens)
    }

    return response
  }

  @Action
  async getGeracaoRepasseAll() {
    const params: any = {
      pagina: this.paginaGeracao,
      qtdPorPagina: this.qtdPorPagina,
      status: this.statusGeracaoRepasse,
      tipo: this.selectedTipo,
      estabelecimentoId: this.fontePagadoraFilter,
      mesAnoCompetencia: this.anoMesReferencia ? `${this.anoMesReferencia}-01` : null,
    }
    const response = await this.remuneracaoMedica.getGeracaoRepasse(params)
    if (response.success) {
      this.context.commit('setGeracaoDeRepassesItems', response.data.itens)
      this.context.commit('setTotalGeracaoDeRepasse', response.data.totalRegistros)
    }
    return response
  }

  @Action
  async getTipoEnum() {
    try {
      const response = await this.remuneracaoMedica.getTipoEnum()
      if (response.success) {
        this.context.commit('setTipoEnum', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getGeracaoDeRepasseItensPrestador(prestadorId: string) {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        id: this.aluguelPrestadorId,
        funcoes: this.funcoes,
        tipo: this.tipoItens,
        numeroAtendimento: this.numeroAtendimento,
        codigo: this.codigoItens,
        operadoraId: this.convenios,
        profissionalId: this.profissionais,
        dataExecucaoDe: this.anoMesReferenciaDe,
        dataExecucaoAte: this.anoMesReferenciaAte,
        apenasDivergente: this.apenasDivergente,
        prestadorRecebimentoId: prestadorId,
      }
      const response = await this.remuneracaoMedica.getGeracaoDeRepasseItensPrestador(params)
      if (response.success) {
        this.context.commit('setGeracaoDeRepassesItemsPrestador', response.data.itens)
        this.context.commit('setTotalItensPrestador', response.data.totalRegistros)
        this.context.commit('setValorTotal', response.data.valorTotal)
        this.context.commit('setQuantidadeTotal', response.data.quantidadeTotal)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async alterarFuncaoGeracaoRepasse() {
    try {
      const params: any = {
        producaoProcedimentoIds: this.itemRepasse,
        novaFuncao: this.alterarFuncao,
      }
      const response = await this.remuneracaoMedica.alterarFuncaoGeracaoRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao alterar' }
    }
  }

  @Action
  async getAllDescontosPrestador(id: string) {
    try {
      const params: any = {
        prestadorId: id,
      }
      const response = await this.remuneracaoMedica.getAllDescontosPrestador(params)
      if (response.success) {
        this.context.commit('setDescontosPrestador', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionalPontuacao() {
    try {
      const params: any = {
        profissionalId: this.profissionalPontuacao,
      }
      const response = await this.remuneracaoMedica.getProfissionalPontuacao(params)
      if (response.success) {
        this.context.commit('setPontuacaoProfissional', this.pontuacoes.find((e: any) => e.id === response.data.itens[0].pontuacaoId))
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPontuacaoProfissional() {
    const response = await this.remuneracaoMedica.getPontuacaoProfissional()
    if (response.success) {
      this.context.commit('setPontuacoes', response.data.itens)
    }
  }

  @Action
  async getProcedimentos() {
    try {
      const request = await this.remuneracaoMedica.getProcedimentos()
      this.context.commit('setProcedimentos', request.success ? request.data.procedimentos : [])
      return request
    } catch (error) {
      this.context.commit('setProcedimentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getValidacaoErros() {
    try {
      const param: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const request = await this.remuneracaoMedica.getValidacaoErros(param)
      this.context.commit('setValidacaoErros', request.success ? request.data.itens : [])
      return request
    } catch (error) {
      this.context.commit('setValidacaoErros', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getTransacaoFinanceira() {
    try {
      const request = await this.remuneracaoMedica.getTransacaoFinanceira()
      this.context.commit('setTransacaoFinanceira', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setTransacaoFinanceira', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCentroDeCusto() {
    try {
      const request = await this.remuneracaoMedica.getCentroDeCusto()
      this.context.commit('setCentroDeCusto', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setCentroDeCusto', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getConvenio() {
    try {
      const response = await this.remuneracaoMedica.getConvenio()
      if (response.success) this.context.commit('setConvenio', response.data.convenios)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar convênios.' }
    }
  }

  @Action
  async getRegistrosValidacao() {
    const params: any = {
      prestadorId: this.prestadorId,
      fontePagadoraId: this.fontePagadoraId,
      nomePaciente: this.nomePaciente,
      operadoraId: this.operadoraId,
      planoOperadoraId: this.planoOperadoraId,
      profissionalExecutanteId: this.profissionais,
      codigoTuss: this.codigoTuss,
      competenciaFaturamentoAnoMes: this.competenciaFaturamentoAnoMes ? `${this.competenciaFaturamentoAnoMes}-01` : this.competenciaFaturamentoAnoMes,
      competenciaRepasseAnoMes: this.competenciaRepasseAnoMes ? `${this.competenciaRepasseAnoMes}-01` : this.competenciaRepasseAnoMes,
      codigoHisRegra: this.codigoRepasse,
      situacao: this.situacoesValidacao,
      erros: this.errosValidacao,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const response = await this.remuneracaoMedica.getRegistrosValidacao(params)
    if (response.success) {
      this.context.commit('setItemsTabelaValidacao', response.data.itens)
      this.context.commit('setItemsTabelaValidacaoTotal', response.data.totalRegistros)
    }

    return response
  }

  @Action
  async fecharGeracaoRepasse() {
    try {
      const params: any = {
        ids: [
          this.idForCloseGeracao,
        ],
      }
      const response = await this.remuneracaoMedica.fecharGeracaoRepasse(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getGeracaoDeRepassesItemsVisualizar(id: string) {
    const params: any = {
      id,
      prestadorId: this.selectedPrestador,
      statusRepasse: this.selectedStatus,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const response = await this.remuneracaoMedica.getGeracaoDeRepassesItemsVisualizar(params)
    if (response.success) {
      this.context.commit('setGeracaoDeRepassesItemsVisualizar', response.data.itens)
      this.context.commit('setAcoesGeracaoRepasse', response.data.acoes)
      this.context.commit('setDadosGeraisDoRepasse', response.data)
      this.context.commit('setAluguelPrestadorId', id)
      this.context.commit('setTotalGeracaoDeRepasseVisualizar', response.data.totalRegistros)
    }
    return response
  }

  @Action
  async getCargasVisualizarItems() {
    const params: any = {
      id: this.idForLoadValidacaoEGeracaoRepasse,
    }
    const response = await this.remuneracaoMedica.getCargasVisualizarItems(params)
    if (response.success) {
      this.context.commit('setCargasVisualizarItems', response.data)
    }
    return response
  }

  @Action
  async getProcedimentosDescartados() {
    try {
      const params: any = {
        id: this.idForLoadProcedimentosDescartados,
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        prestadorId: this.selectedPrestador,
        identificadorHis: this.hisProcedimento,
        numeroAtendimento: this.numeroAtendimento,
        codigo: this.codigoItens,
        profissionalExecutanteId: this.profissionais,
        operadoraId: this.convenios,
        dataExecucaoDe: this.anoMesReferenciaDe,
        dataExecucaoAte: this.anoMesReferenciaAte,
      }
      const response = await this.remuneracaoMedica.getProcedimentosDescartados(params)
      if (response.success) {
        this.context.commit('setProcedimentosDescartados', response.data.itens)
        this.context.commit('setTotalProcedimentosDescartados', response.data.totalRegistros)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na sua requisição!' }
    }
  }

  @Action
  async salvarCodigoAmb() {
    const params: any = {
      medicoProducaoProcedimentoId: this.medicoProducaoProcedimentoId,
      codigoAMB: this.codigoAMB,
    }
    try {
      const response = await this.remuneracaoMedica.salvarCodigoAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelasAMB() {
    try {
      const response = await this.remuneracaoMedica.getTabelasAMB()
      this.context.commit('setTabelasAMB', response.data.itens)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async updateItemTabelaAmb() {
    const params: any = {
      id: this.itemUpdateId,
      codigoAMB: this.codigoAMB,
      codigoTuss: this.codigoTuss,
      descricaoTuss: this.descricaoTuss,
      tabelaAMBId: this.tabelaAmbId,
    }
    try {
      const response = await this.remuneracaoMedica.updateItemTabelaAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async saveEditTableRules() {
    const params: any = {
      codigoHisRegra: this.codigoRepasse || null,
      id: this.itemUpdateId || null,
      profissionalId: this.profissionalRegrasId || null,
      operadoraId: this.convenioRegras || null,
      fontePagadoraId: this.fontePagadoraRegrasId || null,
      fatorRegra: this.multiplicador || null,
      percentualTaxaAdministrativa: this.taxaAdm || null,
      valorDeReferencia: this.valorDeReferencia || null,
      aplicarFatorAcomodacao: this.aplicarFatorAcomodacao || null,
      tabelaPrecoId: this.tabelaReferencia || null,
      tabelaIndiceId: this.tabelaIndice || null,
      tabelaIndiceAtual: this.indiceAtualRegras || null,
    }
    try {
      const response = await this.remuneracaoMedica.saveEditTableRules(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async createItemTabelaAmb() {
    const params: any = {
      codigoAMB: this.codigoAMB,
      codigoTuss: this.codigoTuss,
      descricaoTuss: this.descricaoTuss,
      tabelaAMBId: this.tabelaAmbId,
    }
    try {
      const response = await this.remuneracaoMedica.updateItemTabelaAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteItemTabelaAmb() {
    try {
      const response = await this.remuneracaoMedica.deleteItemTabelaAmb(this.itemUpdateId)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsTabelaAMB() {
    const params: any = {
      tabelaAmbId: this.tabelaId,
    }
    try {
      const response = await this.remuneracaoMedica.getItemsTabelaAMB(params)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.itens.length })
      this.context.commit('setItemsTabelaAmb', response.data.itens)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRegrasProfissional() {
    const params: any = {
      codigoHisRegra: this.codigoRegra,
    }
    try {
      const response = await this.remuneracaoMedica.getItemsRegrasProfissional(params)
      this.context.commit('setItemsRegrasProfissional', response.data.regras)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.totalRegistros })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoAll() {
    try {
      const response = await this.remuneracaoMedica.getTabelaPrecoAll()
      this.context.commit('setItemsTabelaPreco', response.data)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoDetails(pagina: number) {
    try {
      const params: any = {
        pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const response = await this.remuneracaoMedica.getTabelaPrecoDetails(params)
      this.context.commit('setItemsTabelaPrecoDetails', response.data.itens)
      this.context.commit('setItemsTabelaPrecoDetailsPagina', response.data.paginaAtual || 1)
      this.context.commit('setItemsTabelaPrecoDetailsTotal', response.data.totalRegistros || 0)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteItemTabelaPreco(id: number) {
    try {
      const response = await this.remuneracaoMedica.deleteItemTabelaPreco(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoIndice() {
    try {
      const response = await this.remuneracaoMedica.getTabelaPrecoIndice()
      this.context.commit('setItemsTabelaPrecoIndice', response.data.indices)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getConvenioRegras() {
    try {
      const response = await this.remuneracaoMedica.getConvenioRegras()
      this.context.commit('setConveniosRegras', response.data.convenios)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getVisualizarRecebimento(prestadorRecebimentoId: string) {
    try {
      const response = await this.remuneracaoMedica.getRecebimentoNotaFiscalById(prestadorRecebimentoId)
      if (response.success) {
        this.context.commit('setPrestadorRecebimento', response.data)
        this.context.commit('setNotaFiscalUnica', response.data.notasFiscais[0])
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async geRecebimentoById(prestadorRecebimentoId: string) {
    const response = await this.remuneracaoMedica.getRecebimentoNotaFiscalById(prestadorRecebimentoId)
    if (response.success) {
      if (response.data.notaFiscalModoUpload.key === 'Unica') {
        if (response.data.notasFiscais.length) {
          this.context.commit('setDocumentoId', response.data.notasFiscais[0].documentoId)
        }
        this.setModal({ name: 'atualizarNotaFiscal', value: true })
      } else {
        this.setModal({ name: 'multiplasNotasFiscais', value: true })
      }

      if (!response.data.dataRecebimentoNota) {
        response.data.dataRecebimentoNota = ''
      }

      if (!response.data.divergencia) {
        response.data.divergencia = false
      }

      if (!response.data.notaFiscalUrl) {
        response.data.notaFiscalUrl = ''
      }

      if (!response.data.motivo) {
        response.data.motivo = ''
      }

      if (!response.data.numeroNota) {
        response.data.numeroNota = ''
      }

      if (!response.data.numeroContasPagar) {
        response.data.numeroContasPagar = ''
      }

      if (!response.data.empresaMedicaDocumento) {
        response.data.empresaMedicaDocumento = ''
      }

      if (!response.data.comentario) {
        response.data.comentario = ''
      }

      this.context.commit('setPrestadorRecebimento', response.data)
      this.context.commit('setNotaFiscalUnica', response.data.notasFiscais[0])
    }

    return this.prestadorRecebimento
  }

  @Action
  async deleteNotaFiscal() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.prestadorRecebimento.id,
        documentoId: this.idForDeleteNotaFiscal,
      }

      const response = await this.remuneracaoMedica.deleteNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async provisionarRemuneracao(params: any) {
    const response = await this.remuneracaoMedica.provisionarRemuneracao(params)
    return response
  }

  @Action
  async cancelarProvisionamentoRemuneracao(params: any) {
    const response = await this.remuneracaoMedica.cancelarProvisionamentoRemuneracao(params)
    return response
  }

  @Action
  async criarAgrupamentoPrestadorRecebimento() {
    const params: any = {
      anoMesReferencia: moment(this.anoMesReferenciaListaRepasse, 'YYYY-MM').format('YYYY-MM-DD'),
      fontePagadoraId: this.fontePagadoraId,
      // eslint-disable-next-line
      repassesQueSolicitamNF: this.agrupamentoRpas,
    }

    const response = await this.remuneracaoMedica.criarAgrupamentoPrestadorRecebimento(params)
    if (response.success) {
      this.context.commit('setAgrupamentoRepasse', response.data)
    }
    return response
  }

  @Action
  async enviarNotificacaoDeCobranca(params: any) {
    const response = await this.remuneracaoMedica.sendEmailCobrancaNotaFiscal(params)
    if (response.success) {
      this.context.commit('setCargaLogs', response.data)
    }
    return response
  }

  @Action
  async getDocumentoByPrestadorRecebimentoId() {
    try {
      const { id } = this.agrupamentoRepasse.agrupamento
      const response = await this.remuneracaoMedica.getDocumentoByPrestadorRecebimentoId({ id })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItensDoRepasse(id: string) {
    const params: any = {
      pagina: this.pageItems,
      qtdPorPagina: this.qtdPorPagina,
    }
    try {
      const response = await this.remuneracaoMedica.getItensDoRepasse(params, id)
      this.context.commit('setItensDoRepasse', response.data)
      this.context.commit('setTotalItensDoRepasse', response.data.totalRegistros)
      this.context.commit('setItemsId', id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getRelatorioRecebimento() {
    try {
      const params: any = {
        grupoRepasseId: this.grupoRepasse,
        anoMesReferencia: this.anoMesReferenciaExportarRegistros,
        fontePagadoraId: this.fontePagadoraId,
        situacao: this.situacoesExportarRegistros,
        relatorioId: this.relatorioSelected,
        layoutRelatorio: this.layoutRelatorio ? 1 : 0,
      }
      const response = await this.remuneracaoMedica.generateRelatorioGeracaoRepasse(params)
      if (response.success) this.context.commit('setExportarRegistros', response.data)
      return response
    } catch (error) {
      return { message: 'Não foi possível exportar o registro.' }
    }
  }

  @Action
  async liberarRepasses() {
    try {
      const params: any = {
        id: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.liberarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async liberarRepasseUnico() {
    try {
      const params: any = {
        prestadorRecebimentoIds: [this.idForLoadItensRepasse],
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.liberarRepasseUnico(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async integrarRepasses() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.integrarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async integrarRepasseUnico() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItensRepasse,
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.integrarRepasseUnico(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async enfileirar() {
    try {
      const atributosArray = [
        {
          nome: 'GeracaoRepasseId',
          valor: this.idForLoadValidacaoEGeracaoRepasse,
        },
      ]

      this.recalculoIds.forEach((id) => {
        if (this.temProcedimento) {
          atributosArray.push({
            nome: 'MedicoProducaoProcedimentoId',
            valor: id,
          })
        } else {
          atributosArray.push({
            nome: 'MedicoRecebimentoId',
            valor: id,
          })
        }
      })

      const body = {
        tipo: 'GeracaoRecalcular',
        atributos: atributosArray,
      }

      const response = await this.remuneracaoMedica.enfileirar(body)
      this.context.commit('setDescarteId', response.data.id)

      return await this.context.dispatch('getRecalculoRepasse')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async descartarRepasses() {
    try {
      const body = {
        tipo: 'GeracaoDescarteTodos',
        atributos: [
          {
            nome: 'GeracaoRepasseId',
            valor: this.idForLoadValidacaoEGeracaoRepasse,
          },
        ],
      }

      const response = await this.remuneracaoMedica.descartarRepasses(body)
      this.context.commit('setDescarteId', response.data.id)

      return await this.context.dispatch('getDescarteRepasses')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async getTipoCargaDownload(tipoArquivo: string) {
    try {
      const params: any = {
        tipoCarga: this.tipoCargaSelected,
        tipoArquivo,
      }
      const response = await this.remuneracaoMedica.getTipoCargaDownload(params)
      if (response.success) {
        this.context.commit('setDownloadTipoCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível buscar os modelos de carga!', statusCode: 500 }
    }
  }

  @Action
  async desfazerIntegracao() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItensRepasse,
      }
      const response = await this.remuneracaoMedica.desfazerIntegracao(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async desfazerLiberacao() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
        prestadorRecebimentoId: this.idForLoadItensRepasse
      }
      const response = await this.remuneracaoMedica.desfazerLiberacao(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async emitirRelatorio() {
    try {
      const params: any = {
        geracaoRepasseId: [this.idForLoadValidacaoEGeracaoRepasse],
      }

      const response = await this.remuneracaoMedica.emitirRelatoriosEmLote(params)
      this.context.commit('setRelatorioEmissaoId', response.data.relatorioEmissaoId)
      return await this.context.dispatch('getEmissaoRelatorio')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async emitirRelatorioTabelaPropria() {
    try {
      const params: any = {
        tabelaPrecoId: this.tabelaPropria,
      }

      const response = await this.remuneracaoMedica.emitirRelatorioTabelaPropria(params)
      this.context.commit('setRelatorioEmitido', response.data)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async emitirRelatoriosEmLote() {
    try {
      const geracaoRepassesId = this.emitirRelatorioEmLote.map((e: any) => {
        const c = e.id
        return c
      })

      const params: any = {
        geracaoRepasseId: [...geracaoRepassesId],
      }

      const response = await this.remuneracaoMedica.emitirRelatoriosEmLote(params)
      this.context.commit('setRelatorioEmissaoId', response.data.relatorioEmissaoId)
      return await this.context.dispatch('getEmissaoRelatorio')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async getEmissaoRelatorio() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          relatorioEmissaoId: this.relatorioEmissaoId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getEmissaoRelatorio(params)

        if (response.data.processoFinalizado && response.data.arquivoUrl === '') {
          // NÃO REMOVER - PARA DEBUG DO HOSPITAL
          console.log('O processo está finalizado, mas não há URL de arquivo. Encerrando a função.')
          return { success: false }
        }

        if (response.data.processoFinalizado && response.data.arquivoUrl) {
          this.context.commit('setRelatorioEmitido', response.data.arquivoUrl)
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  async getRecalculoRepasse() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          id: this.descarteId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getRecalculoRepasse(params)

        if (response.data.emProcessamento === false) {
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  async getDescarteRepasses() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          id: this.descarteId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getDescarteRepasses(params)

        if (response.data.emProcessamento === false) {
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  delay(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  @Action
  async filtroDownloadNotaFiscal() {
    try {
      const params: any = {
        anoMesReferencia: this.anoMesReferenciaDownloadNotasFiscais ? `${this.anoMesReferenciaDownloadNotasFiscais}-01` : null,
        fontePagadoraId: this.fontePagadoraIdDownloadNotasFiscais || null,
        grupoRepasseId: this.grupoRepasseDownloadNotasFiscais || null,
        createdOnNFDe: this.createdOnNFDe || null,
        createdOnNFAte: this.createdOnNFAte || null,
        status: this.situacoesDoRepasseDownloadNotasFiscais || null,
      }
      const response = await this.remuneracaoMedica.filtroDownloadNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async validarRepasses(params: any) {
    try {
      const response = await this.remuneracaoMedica.validarRepasses(params)
      return response.success
        ? { success: true }
        : { success: false, message: 'Não foi possível realizar esta ação.' }
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async notificarManualmenteRecebimento(params: any) {
    const response = await this.remuneracaoMedica.notificarManualmenteRecebimento(params)
    return response
  }

  @Action
  async atualizarRecebimetno(notaFiscal: PrestadorRecebimento) {
    const response = await this.remuneracaoMedica.atualizarNotaFiscal(notaFiscal)
    return response
  }

  @Action
  async deletarDocumentoPrestadorRecebimento(params: any) {
    const response = await this.remuneracaoMedica.deletarDocumentoPrestadorRecebimento(params)
    return response
  }

  @Action
  async deletarDocumento(params: any) {
    const response = await this.remuneracaoMedica.deletarDocumento(params)
    return response
  }

  @Action
  async importacaoArquivoRecebimento(form: any) {
    const tipoCarga = this.tipoCargaSelected
    const response = await this.remuneracaoMedica.importacaoArquivoRecebimento(form, tipoCarga)
    return response
  }

  @Action
  async uploadNotaFiscal(params: any) {
    const response = await this.remuneracaoMedica.uploadNotaFiscal(params)
    return response
  }

  @Action
  async uploadNotaFiscalUnica(params: any) {
    try {
      const response = await this.remuneracaoMedica.uploadNotaFiscal(params)
      if (response.success) {
        this.context.commit('setIdForConfirmar', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async download(params: any) {
    const response = await this.remuneracaoMedica.download(params)
    return response
  }

  @Action
  async getLogs() {
    const response = await this.remuneracaoMedica.getLogs()
    if (response.success) {
      this.context.commit('setCargaLogs', response.data)
    }
    return response
  }

  @Action
  async sendEmailCobrancaNotaFiscal(params: any) {
    const response = await this.remuneracaoMedica.sendEmailCobrancaNotaFiscal(params)
    if (response.success) {
      this.context.commit('setCargaLogs', response.data)
    }
    return response
  }

  @Action
  async getGrupoRepasseAll() {
    const response = await this.remuneracaoMedica.getGrupoRepasseAll()
    if (response.success) {
      this.context.commit('setGrupoRepasseItensAll', response.data)
    }

    return response
  }

  @Action
  async getDocumentoPrestadorRecebimento(id: string) {
    const response = await this.remuneracaoMedica.getDocumentoPrestadorRecebimento(id)
  }

  @Action
  async atualizarAgrupamento() {
    const params: any = { ...this.agrupamentoRepasse.agrupamento }
    const response = await this.remuneracaoMedica.atualizarAgrupamento(params)
    return response
  }

  @Action
  async deletarNotaFiscal() {
    try {
      const response = await this.remuneracaoMedica.deletarNotaFiscal(this.deleteNotaFiscalId)
      return response
    } catch (error) {
      return { message: error }
    }
  }

  @Action
  async getTemplateNotificacaoConfig(param: any) {
    const response = await this.remuneracaoMedica.getTemplateNotificacaoConfig(param)
    if (response.success) {
      this.context.commit('setTemplateNotificarConfig', response.data)
    }
    return response
  }

  @Action
  async recalcular() {
    try {
      const params: any = {
        salvarCalculoParaValidacao: false,
        recalcularERecriarRecebimentos: true,
        mesReferencia: `${this.anoMesReferenciaRecalcularValores}-01`,
        dataRecebimento: this.dataRecebimentoRecalcularValores,
        prazo: this.prazoRecalcularValores,
      }
      // O método não existe ainda... Corrigido problema de lint por hora usando tipagem any
      const response = await (Apis.Legacy.Producao as any).recalcular(params)
      return response
    } catch (error) {
      return { message: 'Não foi possível calcular os repasses.' }
    }
  }

  @Action
  async getPessoaPrestadorAll(params: any = {}) {
    const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
    if (response.success) {
      const prestadores = response.data.prestadores
        ? response.data.prestadores
        : []
      this.context.commit('setPrestadoresLista', prestadores)
    }
    return response
  }

  @Action
  async getImpostoPrestador(params: any = {}) {
    const response = await this.remuneracaoMedica.getImpostoPrestador(params)
    if (response.success) {
      const prestadores = response.data.itens
        ? response.data.itens
        : []
      this.context.commit('setImpostoPrestadorList', prestadores)
    }
    return response
  }

  @Action
  async alterarPrestador(params: any) {
    const response = await this.remuneracaoMedica.alterarPrestador(params)
    return response
  }

  @Action
  async deletarRepasse() {
    const response = await this.remuneracaoMedica.deletarRepasse(this.solicitacaoId)
    return response
  }

  /**
   * PAGINAÇÃO TABELA DE REFERÊNCIA
   */

  public pagination: any = {
    descending: false,
    page: 1,
    rowsPerPage: 50,
    sortBy: null,
    totalItems: null,
    rowsPerPageItems: [10, 25, 50, 100, -1],
  }

  @Mutation
  setPagination(value: any) {
    this.pagination = value
  }

  /**
   * Items de senioridade
   */
  private itemsSenioridadeDefault: ItemSenioridade[] = []
  public itemsSenioridade: ItemSenioridade[] = [...this.itemsSenioridadeDefault]
  private itemSenioridadeDefault: ItemSenioridade = {
    id: '',
    nome: '',
    codigoPontuacao: '',
    percentual: '',
    tabelaPrecoId: '',
  }

  public originalItemSenioridade: ItemSenioridade = { ...this.itemSenioridadeDefault }

  public itemSenioridade: ItemSenioridade = { ...this.itemSenioridadeDefault }
  public itemsSenioridadePagina: number = 1
  public itemsSenioridadeQtdPorPagina: number = 50
  public itemsSenioridadeTotal: number = 0

  @Mutation
  setItemsSenioridade(value: ItemSenioridade[]) {
    this.itemsSenioridade = value
  }

  @Mutation
  clearItemsSenioridade() {
    this.itemsSenioridade = []
  }

  @Mutation
  setItemSenioridade(value: ItemSenioridade) {
    this.itemSenioridade = value
  }

  @Mutation
  clearItemSenioridade() {
    this.itemSenioridade = { ...this.itemSenioridadeDefault }
  }

  @Mutation
  setOriginalItemSenioridade(value: ItemSenioridade) {
    this.originalItemSenioridade = value
  }

  @Mutation
  clearOriginalItemSenioridade() {
    this.originalItemSenioridade = { ...this.itemSenioridadeDefault }
  }

  @Mutation
  setItemsSenioridadePagina(value: number) {
    this.itemsSenioridadePagina = value
  }

  @Mutation
  setItemsSenioridadeTotal(value: number) {
    this.itemsSenioridadeTotal = value
  }

  @Mutation
  removeItemSenioridade(id: string) {
    const index = this.itemsSenioridade.findIndex((e: any) => e.id === id)
    this.itemsSenioridade.splice(index, 1)
  }

  @Action
  async getAllItemsSenioridade() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }

      const request = await this.remuneracaoMedica.getAllItemsSenioridade(params)

      if (request.success) {
        this.context.commit('setItemsSenioridade', request.data.itens as ItemSenioridade[])
        this.context.commit('setItemsSenioridadePagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsSenioridadeTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsSenioridade', [])
      return { success: false, message: error }
    }
  }

  @Action
  async createItemsSenioridade() {
    try {
      const { nome, codigoPontuacao, percentual, tabelaPrecoId } = this.itemSenioridade
      const params: any = { nome, codigoPontuacao, percentual, tabelaPrecoId }
      const request = await this.remuneracaoMedica.createItemsSenioridade(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateItemsSenioridade() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemSenioridade, this.originalItemSenioridade)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, nome, codigoPontuacao, percentual, tabelaPrecoId } = this.itemSenioridade
      const params: any = { id, nome, codigoPontuacao, percentual, tabelaPrecoId }
      const request = await this.remuneracaoMedica.updateItemsSenioridade(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteItemSenioridade(id: string) {
    try {
      const request = await this.remuneracaoMedica.deleteItemSenioridade(id)
      if (request.success) this.context.commit('removeItemSenioridade', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Items da tabela preço procedimento
   */
  public itemTabelaReferenciaId: string | number = ''
  private itemsTabelaPrecoProcedimentoDefault: ItemTabelaPrecoProcedimento[] = []
  public itemsTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento[] = [...this.itemsTabelaPrecoProcedimentoDefault]
  private itemTabelaPrecoProcedimentoDefault: ItemTabelaPrecoProcedimento = {
    id: '',
    codigoUnico: '',
    descricao: '',
    valorProcedimento: 0,
    fatorViaUnica: 0,
    fatorViaMesma: 0,
    fatorViaSeparada: 0,
    fatorViaBilateral: 0,
    valorDiurno: 0,
    valorDomingo: 0,
    valorFeriado: 0,
    valorMadrugada: 0,
    valorNoturno: 0,
    valorPediatria: 0,
    valorSabado: 0,
    valorUrgencia: 0,
  }

  public originalItemTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }

  public itemTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  public itemsTabelaPrecoProcedimentoPagina: number = 1
  public itemsTabelaPrecoDetailsPagina: number = 1
  public itemsTabelaPrecoProcedimentoQtdPorPagina: number = 50
  public itemsTabelaPrecoProcedimentoTotal: number = 0
  public itemsTabelaPrecoDetailsTotal: number = 0

  @Mutation
  setItemTabelaReferenciaId(value: string | number) {
    this.itemTabelaReferenciaId = value
  }

  @Mutation
  clearItemTabelaReferenciaId() {
    this.itemTabelaReferenciaId = ''
  }

  @Mutation
  setItemsTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento[]) {
    this.itemsTabelaPrecoProcedimento = value
  }

  @Mutation
  removeItemFromTabelaPrecoProcedimento(id: string | number) {
    const index = this.itemsTabelaPrecoProcedimento.findIndex((e: any) => e.id === id)
    this.itemsTabelaPrecoProcedimento.splice(index, 1)
  }

  @Mutation
  clearItemsTabelaPrecoProcedimento() {
    this.itemsTabelaPrecoProcedimento = []
  }

  @Mutation
  setItemTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento) {
    this.itemTabelaPrecoProcedimento = value
  }

  @Mutation
  clearItemTabelaPrecoProcedimento() {
    this.itemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  }

  @Mutation
  setOriginalItemTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento) {
    this.originalItemTabelaPrecoProcedimento = value
  }

  @Mutation
  clearOriginalItemTabelaPrecoProcedimento() {
    this.originalItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  }

  @Mutation
  setItemsTabelaPrecoProcedimentoPagina(value: number) {
    this.itemsTabelaPrecoProcedimentoPagina = value
  }

  @Mutation
  setItemsTabelaPrecoDetailsPagina(value: number) {
    this.itemsTabelaPrecoDetailsPagina = value
  }

  @Mutation
  setItemsTabelaPrecoDetailsTotal(value: number) {
    this.itemsTabelaPrecoDetailsTotal = value
  }

  @Mutation
  setItemsTabelaPrecoProcedimentoTotal(value: number) {
    this.itemsTabelaPrecoProcedimentoTotal = value
  }

  @Action
  async getItensByTabelaDeReferenciaId() {
    try {
      const params: any = {
        tabelaReferenciaId: this.itemTabelaReferenciaId,
        codigo: this.searchCodigoDebounce,
        descricao: this.searchDescricaoDebounce,
        pagina: this.itemsTabelaPrecoProcedimentoPagina,
        qtdPorPagina: this.itemsTabelaPrecoProcedimentoQtdPorPagina,
      }

      const request = await this.remuneracaoMedica.getItensByTabelaDeReferenciaId(params)

      if (request.success) {
        this.context.commit('setItemsTabelaPrecoProcedimento', request.data.itens as ItemTabelaPrecoProcedimento[])
        this.context.commit('setItemsTabelaPrecoProcedimentoPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaPrecoProcedimentoTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsTabelaPrecoProcedimento', [])
      return { success: false, message: error }
    }
  }

  @Action
  async createItemsTabelaPrecoProcedimento() {
    try {
      const params: any = { tabelaPrecoId: this.itemTabelaReferenciaId, ...this.itemTabelaPrecoProcedimento }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
        if (key === 'id') delete params[key]
      })

      const request = await this.remuneracaoMedica.createItensByTabelaDeReferenciaId(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateItemByTabelaDeReferenciaId() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemTabelaPrecoProcedimento, this.originalItemTabelaPrecoProcedimento)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, codigoUnico, descricao, valorProcedimento, fatorViaUnica, fatorViaMesma, fatorViaSeparada, fatorViaBilateral, valorDiurno, valorDomingo, valorFeriado, valorMadrugada, valorNoturno, valorPediatria, valorSabado, valorUrgencia } = this.itemTabelaPrecoProcedimento

      const params: any = {
        tabelaPrecoId: this.itemTabelaReferenciaId,
        tabelaPrecoProcedimentoId: id,
        id,
        codigoUnico,
        descricao,
        valorProcedimento,
        fatorViaUnica,
        fatorViaMesma,
        fatorViaSeparada,
        fatorViaBilateral,
        valorDiurno,
        valorDomingo,
        valorFeriado,
        valorMadrugada,
        valorNoturno,
        valorPediatria,
        valorSabado,
        valorUrgencia,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updateItemByTabelaDeReferenciaId(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteItemByTabelaDeReferenciaId(id: string | number) {
    try {
      const request = await this.remuneracaoMedica.deleteItemByTabelaDeReferenciaId({
        tabelaPrecoId: this.itemTabelaReferenciaId,
        tabelaPrecoProcedimentoId: id,
      })
      if (request.success) this.context.commit('removeItemFromTabelaPrecoProcedimento', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Itens da tabela taxa de aluguel
   */
  @Action
  async getPrestadorTaxaAluguel(params: any = {}) {
    const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
    if (response.success) {
      const prestadores = response.data.prestadores
        ? response.data.prestadores
        : []
      prestadores.unshift({ userId: '', nome: TAXA_PADRAO, documento: '' })
      this.context.commit('setPrestadoresLista', prestadores)
    }
    return response
  }

  private profissionalIdDefault: string = ''
  public profissionalId: string = this.profissionalIdDefault
  private itemsPontuacaoProfissionalDefault: ItemPontuacaoProfissional[] = []
  public itemsPontuacaoProfissional: ItemPontuacaoProfissional[] = [...this.itemsPontuacaoProfissionalDefault]
  private itemPontuacaoProfissionalDefault: ItemPontuacaoProfissional = {
    id: '',
    pontuacaoId: '',
    profissionalId: '',
  }

  public itemPontuacaoProfissional: ItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  public originalItemPontuacaoProfissional: ItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }

  public itemsTabelaPontuacaoProfissionalPagina: number = 1
  public paginaVinculosRelatorios: number = 1
  public itemsTabelaPontuacaoProfissionalQtdPorPagina: number = 50
  public itemsTabelaPontuacaoProfissionalTotal: number = 0
  public totalItemsVinculos: number = 0
  public totalItemsImpostoPrestador: number = 0

  @Mutation
  setItemsTabelaPontuacaoProfissionalPagina(value: number) {
    this.itemsTabelaPontuacaoProfissionalPagina = value
  }

  @Mutation
  setPaginaVinculosRelatorios(value: number) {
    this.paginaVinculosRelatorios = value
  }

  @Mutation
  setItemsTabelaPontuacaoProfissionalTotal(value: number) {
    this.itemsTabelaPontuacaoProfissionalTotal = value
  }

  @Mutation
  setTotalItemsVinculos(value: number) {
    this.totalItemsVinculos = value
  }

  @Mutation
  setTotalItemsImpostoPrestador(value: number) {
    this.totalItemsImpostoPrestador = value
  }

  @Mutation
  setVinculosRelatorios(value: any[]) {
    this.vinculosRelatorios = value
  }

  @Mutation
  setImpostoPrestadores(value: any[]) {
    this.impostoPrestadores = value
  }

  @Mutation
  setRelatoriosAll(value: any[]) {
    this.relatoriosAll = value
  }

  @Mutation
  clearItemVinculoRelatorio() {
    this.relatorioId = ''
    this.pessoaId = ''
  }

  @Mutation
  clearItemImpostoPrestador() {
    this.alicota = ''
    this.impostoPrestadorId = ''
    this.impostoId = ''
    this.valorMinimoTributo = ''
    this.pessoaId = ''
  }

  @Mutation
  setItemPontuacaoProfissional(value: ItemPontuacaoProfissional) {
    this.itemPontuacaoProfissional = value
  }

  @Mutation
  clearItemPontuacaoProfissional() {
    this.itemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  }

  @Mutation
  setIdForEditItemImpostoPrestador(value: string) {
    this.impostoPrestadorId = value
  }

  @Mutation
  setEditItemImpostoPrestador(item: any) {
    this.impostoId = item.impostoId
    this.alicota = item.alicota
    this.pessoaId = item.prestadorid
  }

  @Mutation
  setProfissionalId(value: string) {
    this.profissionalId = value
  }

  @Mutation
  clearProfissionalId() {
    this.profissionalId = this.profissionalIdDefault
  }

  @Mutation
  setItemsPontuacaoProfissional(value: ItemPontuacaoProfissional[]) {
    this.itemsPontuacaoProfissional = value
  }

  @Mutation
  clearItemsPontuacaoProfissional() {
    this.itemsPontuacaoProfissional = [...this.itemsPontuacaoProfissionalDefault]
  }

  @Mutation
  setOriginalItemPontuacaoProfissional(value: ItemPontuacaoProfissional) {
    this.originalItemPontuacaoProfissional = value
  }

  @Mutation
  clearOriginalItemPontuacaoProfissional() {
    this.originalItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  }

  @Mutation
  removeItemFromPontuacaoProfissional(id: string | number) {
    const index = this.itemsPontuacaoProfissional.findIndex((e: any) => e.id === id)
    this.itemsPontuacaoProfissional.splice(index, 1)
  }

  @Action
  async getPontuacaoProfissionalAll() {
    try {
      const request = await this.remuneracaoMedica.getPontuacaoProfissionalAll({
        profissionalId: this.profissionalId,
        pagina: this.itemsTabelaPontuacaoProfissionalPagina,
        qtdPorPagina: this.itemsTabelaPontuacaoProfissionalQtdPorPagina,
      })

      if (request.success) {
        this.context.commit('setItemsPontuacaoProfissional', request.data.itens as ItemPontuacaoProfissional[])
        this.context.commit('setItemsTabelaPontuacaoProfissionalPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaPontuacaoProfissionalTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async criarVinculoRelatorio() {
    try {
      const params: any = {
        relatorioId: this.relatorioId,
        pessoaId: this.pessoaId,
      }
      const request = await this.remuneracaoMedica.criarVinculoRelatorio(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async criarImpostoPrestador() {
    try {
      const params: any = {
        prestadorId: this.pessoaId,
        impostoId: this.impostoId,
        alicota: parseFloat(this.alicota),
        valorMinimoTributo: parseFloat(this.valorMinimoTributo),
      }
      const request = await this.remuneracaoMedica.criarImpostoPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async editarImpostoPrestador() {
    try {
      const params: any = {
        id: this.impostoPrestadorId,
        prestadorId: this.pessoaId,
        impostoId: this.impostoId,
        alicota: parseFloat(this.alicota),
        valorMinimoTributo: parseFloat(this.valorMinimoTributo),
      }
      const request = await this.remuneracaoMedica.criarImpostoPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  public relatorioIdFilter: string = ''
  public pessoaIdFilter: string = ''
  public areaFilter: string = ''

  @Mutation
  setRelatorioIdFilter(value: string) {
    this.relatorioIdFilter = value
  }

  @Mutation
  setPessoaIdFilter(value: string) {
    this.pessoaIdFilter = value
  }

  @Mutation
  setAreaFilter(value: string) {
    this.areaFilter = value
  }

  @Action
  async getVinculosRelatorios() {
    try {
      const params: any = {
        relatorioId: this.relatorioIdFilter,
        pessoaId: this.pessoaIdFilter,
        area: this.areaFilter,
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const request = await this.remuneracaoMedica.getVinculosRelatorios(params)


      if (request.success) {
        this.context.commit('setVinculosRelatorios', request.data.itens)
        this.context.commit('setTotalItemsVinculos', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getImpostoPrestadores() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const request = await this.remuneracaoMedica.getImpostoPrestadores(params)


      if (request.success) {
        this.context.commit('setImpostoPrestadores', request.data.itens)
        this.context.commit('setTotalItemsImpostoPrestador', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getRelatoriosAll() {
    try {
      const request = await this.remuneracaoMedica.getRelatoriosAll()

      if (request.success) {
        this.context.commit('setRelatoriosAll', request.data.itens)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async createPontuacaoProfissional() {
    try {
      const params: any = { ...this.itemPontuacaoProfissional }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.createPontuacaoProfissional(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updatePontuacaoProfissional() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemPontuacaoProfissional, this.originalItemPontuacaoProfissional)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, profissionalId, pontuacaoId } = this.itemPontuacaoProfissional

      const params: any = {
        id,
        profissionalId,
        pontuacaoId,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updatePontuacaoProfissional(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deletePontuacaoProfissional(id: string) {
    try {
      const request = await this.remuneracaoMedica.deletePontuacaoProfissional(id)
      if (request.success) this.context.commit('removeItemFromPontuacaoProfissional', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async deleteVinculoRelatorio(id: string) {
    try {
      const param: any = {
        relatorioPerfilId: id,
      }
      const request = await this.remuneracaoMedica.deleteVinculoRelatorio(param)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async deleteImpostoPrestador(id: string) {
    try {
      const param: any = {
        id,
      }
      const request = await this.remuneracaoMedica.deleteImpostoPrestador(param)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Itens da tabela de taxa de aluguel
   */
  private itemsTaxaAluguelDefault: ItemTaxaAluguel[] = []
  public itemsTaxaAluguel: ItemTaxaAluguel[] = [...this.itemsTaxaAluguelDefault]
  private itemTaxaAluguelDefault: ItemTaxaAluguel = {
    id: '',
    prestadorId: '',
    tipo: TaxaAluguelTipoEnum.Fixo,
    valor: 0,
  }

  public itemTaxaAluguel: ItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  public originalItemTaxaAluguel: ItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }

  private taxaAluguelPrestadorDefault: PrestadorTaxaAluguel = {
    userId: '',
    nome: '',
    documento: '',
  }

  public taxaAluguelPrestador: PrestadorTaxaAluguel = { ...this.taxaAluguelPrestadorDefault }
  public itemsTabelaTaxaAluguelPagina: number = 1
  public itemsTabelaTaxaAluguelQtdPorPagina: number = 50
  public itemsTabelaTaxaAluguelTotal: number = 0

  @Mutation
  setTaxaAluguelPrestador(value: PrestadorTaxaAluguel) {
    this.taxaAluguelPrestador = value
  }

  @Mutation
  clearTaxaAluguelPrestador() {
    this.taxaAluguelPrestador = { ...this.taxaAluguelPrestadorDefault }
  }

  @Mutation
  setItemsTabelaTaxaAluguelPagina(value: number) {
    this.itemsTabelaTaxaAluguelPagina = value
  }

  @Mutation
  setItemsTabelaTaxaAluguelTotal(value: number) {
    this.itemsTabelaTaxaAluguelTotal = value
  }

  @Mutation
  setItemTaxaAluguel(value: ItemTaxaAluguel) {
    this.itemTaxaAluguel = value
  }

  @Mutation
  clearItemTaxaAluguel() {
    this.itemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  }

  @Mutation
  setItemsTaxaAluguel(value: ItemTaxaAluguel[]) {
    const mappedValue = value.map((item: ItemTaxaAluguel) => {
      const i = item
      if (['', null, undefined].includes(i.nomePrestador) || ['', null, undefined].includes(i.prestadorId)) {
        i.nomePrestador = TAXA_PADRAO
      }
      return i
    })
    this.itemsTaxaAluguel = mappedValue
  }

  @Mutation
  clearItemsTaxaAluguel() {
    this.itemsTaxaAluguel = [...this.itemsTaxaAluguelDefault]
  }

  @Mutation
  setOriginalItemTaxaAluguel(value: ItemTaxaAluguel) {
    this.originalItemTaxaAluguel = value
  }

  @Mutation
  clearOriginalItemTaxaAluguel() {
    this.originalItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  }

  @Mutation
  removeItemFromTaxaAluguel(id: string | number) {
    const index = this.itemsTaxaAluguel.findIndex((e: any) => e.id === id)
    this.itemsTaxaAluguel.splice(index, 1)
  }

  @Action
  async getTaxaAluguelAll() {
    try {
      const request = await this.remuneracaoMedica.getTaxaAluguelAll({
        prestadorId: this.taxaAluguelPrestador.userId,
        taxaPadrao: this.taxaAluguelPrestador.taxaPadrao,
        pagina: this.itemsTabelaTaxaAluguelPagina,
        qtdPorPagina: this.itemsTabelaTaxaAluguelQtdPorPagina,
      })

      if (request.success) {
        this.context.commit('setItemsTaxaAluguel', request.data.itens as ItemTaxaAluguel[])
        this.context.commit('setItemsTabelaTaxaAluguelPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaTaxaAluguelTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async createTaxaAluguel() {
    try {
      const params: any = { ...this.itemTaxaAluguel }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.createTaxaAluguel(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateTaxaAluguel() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemTaxaAluguel, this.originalItemTaxaAluguel)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, prestadorId, tipo, valor } = this.itemTaxaAluguel

      const params: any = {
        id,
        prestadorId,
        tipo,
        valor,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updateTaxaAluguel(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteTaxaAluguel(id: string) {
    try {
      const request = await this.remuneracaoMedica.deleteTaxaAluguel(id)
      if (request.success) this.context.commit('removeItemFromTaxaAluguel', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async getPrestadorTaxaAluguelAll(params: any = {}) {
    try {
      const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
      if (response.success) {
        const prestadores = response.data.prestadores ? response.data.prestadores : []
        prestadores.unshift({ userId: '', nome: 'TAXA PADRÃO', documento: '', taxaPadrao: true })
        this.context.commit('setPrestadoresLista', prestadores)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  private motivoExclusaoItemRepasseDefault: any = {
    ids: [''],
    motivoExclusao: '',
    observacaoMotivoExclusao: '',
  }

  public motivoExclusaoItemRepasse: any = { ...this.motivoExclusaoItemRepasseDefault }
  public recalculoIds: string[] = ['']

  @Mutation
  setMotivoExclusaoItemRepasseId(ids: any) {
    this.motivoExclusaoItemRepasse.ids = ids
  }

  @Mutation
  setRecalculoIds(ids: any) {
    this.recalculoIds = ids
  }

  @Mutation
  clearMotivoExclusaoItemRepasse() {
    this.motivoExclusaoItemRepasse = { ...this.motivoExclusaoItemRepasseDefault }
  }

  @Action
  async excluirItemRepasse() {
    try {
      const request = await this.remuneracaoMedica.excluirItemRepasse(this.motivoExclusaoItemRepasse)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getStatusGeracaoRepasse() {
    try {
      const request = await this.remuneracaoMedica.getStatusGeracaoRepasse()
      this.context.commit('setStatusGeracaoRepasseFiltro', request.data)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }


  // SIGNALR REMUNERACAO MEDICA

  message: IRemuneracaoBackofficeMessage[] = []
  grupoHospitalId: string = ''
  gruposHospitaisIds: string[] = []


  @Mutation
  setGrupoHospital(value: any) {
    this.grupoHospitalId = value
  }

  @Mutation
  setGruposHospitaisIds(value: any) {
    this.gruposHospitaisIds = value
  }

  @Mutation
  addMessage(data: IRemuneracaoBackofficeMessage) {
    this.message.push(data)
  }

  @Action
  async getGrupoHospital() {
    try {
      const request = await this.remuneracaoMedica.getGrupoHospital()
      this.context.commit('setGrupoHospital', request.data.id)
      this.context.commit('setGruposHospitaisIds', request.data.hospitaisId)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async openConnection(grupoHospitalId: any) {
    await signalRRemuneracaoBackofficeService.openConnection(grupoHospitalId)
  }

  @Action
  async closeConnection() {
    await signalRRemuneracaoBackofficeService.closeConnection()
  }

  /** Seleção de itens de repassse para liberar ou integrar */
  itensDeRepasseSelecionados: any[] = []

  @Mutation
  setItensDeRepasseSelecionados(value: any) {
    this.itensDeRepasseSelecionados = value
  }

  @Mutation
  clearItensDeRepasseSelecionados() {
    this.itensDeRepasseSelecionados = []
  }

  @Action
  async integrarItensDeGeracaoDeRepasseNoHis() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse || this.aluguelPrestadorId,
        prestadorRecebimentoIds: filtrarItensPorAcao(this.itensDeRepasseSelecionados, 'PodeIntegrar').map((item: any) => item.id),
      }
      const request = await this.remuneracaoMedica.integrarItensDeGeracaoDeRepasseNoHis(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async liberarItensDeGeracaoDeRepasseNoHis() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse || this.aluguelPrestadorId,
        // prestadorRecebimentoIds: [
        //   '38f126f2-3535-4f79-99cc-98a6270e46f7',
        //   'cc9fc57d-b657-4b4f-9362-a28abed89493',
        //   '65afaaaa-5bd3-4b37-a9bd-7fb6a982e870',
        //   '35838cc4-f442-42ce-9226-848a9d560b9c',
        //   'a2c1c0f4-0144-4439-9962-4608cbe5f640',
        //   'fa2050c4-741a-412f-9db6-107ed1d58cdd',
        //   '13e4f4c4-0176-49a4-aa5c-2a35a156933f',
        //   'b3bd7bfe-036f-4ed5-bc31-3a115d69d0ba',
        //   '066b9b6f-b069-4ac3-a87f-045f9fa6f35a',
        //   '4eab4c4f-e134-4d67-af72-017438fe5006',
        // ],
        prestadorRecebimentoIds: filtrarItensPorAcao(this.itensDeRepasseSelecionados, 'PodeLiberar').map((item: any) => item.id),
      }
      const request = await this.remuneracaoMedica.liberarItensDeGeracaoDeRepasseNoHis(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  public relatoriosAreaEnum: Array<{ key: string, display: string }> = []

  @Mutation
  setRelatoriosAreaEnum(value: Array<{ key: string, display: string }>) {
    this.relatoriosAreaEnum = value
  }

  @Mutation
  clearRelatoriosAreaEnum() {
    this.relatoriosAreaEnum = []
  }

  @Action
  async getRelatoriosAreaEnum() {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getRelatoriosAreaEnum()
      if (request.success) this.context.commit('setRelatoriosAreaEnum', request.data as Array<{ key: string, display: string }> || [])
      return request
    } catch (error) {
      this.context.commit('setRelatoriosAreaEnum', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
